/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
/* eslint-disable max-len */
export const ES_ES = {
    'test': 'test-test', // unit test do not delete
    'test_with_two_parameters': 'Test {{placeholder1}} test2 {{placeholder2}}', // unit test do not delete
    'color': 'color',

    '403_access_denied': 'Acceso denegado',
    '404': '404: falta página',
    '404_page_not_found': 'Página no encontrada',
    'Required': 'Requerido', // Has capital key for validation component
    'account_enter_current_password': 'Por favor, introduzca su contraseña actual para continuar.',
    'account_private_key_message': 'Su clave es única para usted. La recuperación de contraseña depende de su validación y, por lo tanto, requiere que la descargue y la guarde en un lugar seguro.',
    'accounts_download_key': 'Descargar clave',
    'accounts_password_message': 'Deje los campos en blanco si no va a cambiar la contraseña',
    'accounts_recover_password': 'Restablecer contraseña',
    'accounts_recover_password_complete_redirect_message': 'Ir a la página de inicio de sesión del portal',
    'accounts_recover_password_email_label': 'Correo electrónico registrado',
    'accounts_recover_password_intro': 'Para restablecer su contraseña, ingrese su correo electrónico registrado y su clave privada de usuario.',
    'accounts_recover_password_intro_2': 'Ahora, por favor introduzca su nueva contraseña a continuación.',
    'accounts_recover_password_redirect_login': 'Volver a la página de inicio de sesión',
    'accounts_recover_password_upload_org_message': 'Seleccione la clave privada de su organización',
    'accounts_recover_password_upload_user_message': 'Seleccione su clave privada de usuario',
    'accounts_recovery_download_key': 'Descargar clave privada',
    'accounts_recovery_download_key_org': 'Descargar clave de organización',
    'accounts_recovery_download_success_message': 'descargado con éxito',
    'accounts_recovery_keep_keys_safe': '¡Por favor, guarde sus claves en un lugar seguro!',
    'accounts_recovery_keep_keys_safe_message': 'Si olvida sus datos de inicio de sesión y necesita restablecer su cuenta, asegúrese de descargar sus claves.',
    'accounts_settings': 'Configuración de la cuenta',
    'accounts_settings_login_out_now': 'Cerrar sesión ahora',
    'accounts_settings_phone_number_disabled': 'No puede cambiar su número de teléfono ya que la autenticación en dos pasos por SMS está habilitada',
    'accounts_single-sign-on': 'Inicio de sesión único (SSO)',
    'accounts_sso_message': 'Seleccione un cliente SSO para usar en el inicio de sesión del portal',
    'accounts_sso_disabled_message': 'El SSO está deshabilitado porque su organización tiene implementado SAML.',
    'accounts_sso_upgrade_message': 'Mejore la seguridad de su organización utilizando SSO para el acceso al portal. ¡Es bueno!',
    'accounts_sso_upgrade_title': 'Actualizar para usar SSO',
    'accounts_two_factor_auth': 'Autenticación de dos factores',
    'accounts_two_factor_auth_app': 'APP',
    'accounts_two_factor_auth_app_code_message': 'Alternativamente, copia el código de abajo y pégalo en tu aplicación de autenticación.',
    'accounts_two_factor_auth_app_message': 'Use una aplicación como Google Authenticator para generar códigos de verificación.',
    'accounts_two_factor_auth_app_title': 'Aplicación de autenticación',
    'accounts_two_factor_auth_app_using': 'Usando la aplicación',
    'accounts_two_factor_auth_disable_app_message': '¿Está seguro de que desea desactivar la verificación de la aplicación de autenticación?',
    'accounts_two_factor_auth_disable_sms_message': '¿Está seguro de que desea desactivar la verificación por SMS?',
    'accounts_two_factor_auth_disable_tooltip': 'Solo puede usar un método de verificación 2FA, para cambiar a otro método debe desactivar este primero.',
    'accounts_two_factor_auth_incorrect_code': 'El código no coincide, por favor inténtelo de nuevo.',
    'accounts_two_factor_auth_message': 'Proteja el inicio de sesión de su cuenta con la verificación en dos pasos.',
    'accounts_two_factor_auth_phone_message': 'Los números de teléfono solo pueden contener números del 0 al 9',
    'accounts_two_factor_auth_required': 'Autenticación de dos factores requerida',
    'accounts_two_factor_auth_resend': 'Reenviar código',
    'accounts_two_factor_auth_sms': 'SMS',
    'accounts_two_factor_auth_sms_message': 'Use mensajes de texto para recibir códigos de verificación.',
    'accounts_two_factor_auth_sms_using': 'Usando móvil',
    'accounts_two_factor_auth_upgrade_message': 'Mejore la seguridad de su organización utilizando la autenticación de dos factores para el acceso al portal. ¡Es bueno!',
    'accounts_two_factor_auth_upgrade_title': 'Actualizar para usar la autenticación de dos factores',
    'accounts_two_factor_auth_use_app': 'Escanee el código QR desde su aplicación de autenticación.',
    'accounts_two_factor_auth_use_app_code': 'Por favor, introduzca el código de confirmación que ve en su aplicación de autenticación.',
    'accounts_two_factor_auth_use_sms': 'Use mensajes de texto (SMS) para recibir códigos de verificación.',
    'accounts_two_factor_auth_use_sms_code': 'Ingrese el código de verificación de 6 dígitos que le hemos enviado a',
    'acl_delete': 'Eliminar ACL',
    'acl_delete_message': '¿Está seguro de que desea eliminar esta regla de ACL?',
    'acl_details_add_disabled_hint': 'La ACL de capa 4 solo puede contener una única regla',
    'acl_details_return_to': 'Volver a los detalles de ACL',
    'acl_edit': 'Editar ACL',
    'acl_select_layer': 'Seleccionar capa de ACL',
    'acl_select_layer_message': 'Seleccione la capa para la que desea crear la ACL.',
    'acls_backend_mode_type': 'El backend es de tipo de modo. ',
    'acls_frontend_mode_type': 'El frontend es de tipo de modo. ',
    'acls_header_param': 'Encabezado/Parámetro',
    'acls_no_compatible_backends': 'No hay backends compatibles. ',
    'acls_no_compatible_frontends': 'No hay frontends compatibles. ',
    'acls_redirect_with_code': 'Redirigir con código',
    'acls_type_layer4_warning': 'Los frontends de capa 4 solo pueden tener una única regla ACL.',
    'acls_type_mismatch_message': 'El frontend y el backend deben ser del mismo tipo, por ejemplo, capa 7',
    'acls_type_warning_message': 'Este asistente es solo para ACL de capa 7. Para actualizar una regla de ACL para un frontend de capa 4, acceda a la ACL mediante la página "Administrar ACL".',
    'activate_account_complete': 'Completar activación de cuenta',
    'activate_account_error': 'Error de activación',
    'activate_activation_passcode': 'Código de activación',
    'activate_logging_in': 'Iniciando sesión',
    'activate_marketing_title': 'Confirmar dirección de correo electrónico',
    'activate_portal_activated': '¡Su portal Loadbalancer ha sido activado!',
    'adc_add': 'Añadir ADC',
    'adc_add_address': 'Detalles de gestión del ADC',
    'adc_add_api_details': 'Detalles de configuración de la API',
    'adc_add_instance': 'Añadir una instancia de ADC',
    'adc_add_login_details': 'Detalles de inicio de sesión del ADC',
    'adc_add_message_a10': 'Los balanceadores de carga A10 Thunder facilitan la entrega de aplicaciones eficiente y confiable, en cualquier entorno. Ofrecen aplicaciones seguras, visibles y altamente disponibles para velocidad y agilidad.',
    'adc_add_message_citrix': 'Citrix NetScaler simplifica y automatiza la entrega y seguridad de aplicaciones en entornos locales y en la nube, proporcionando aplicaciones de alto rendimiento, resilientes y seguras, sin importar el tipo de aplicación y la infraestructura subyacente.',
    'adc_add_message_edgenexus': 'Los ADCs de EdgeNexus ofrecen servicios resilientes y receptivos con control granular sobre el tráfico de aplicaciones, y entrega de aplicaciones segura y confiable para aplicaciones siempre activas que son fáciles de desplegar.',
    'adc_add_message_endurance': 'Loadbalancer Endurance es un balanceador de carga de nueva generación, construido para un mundo nativo en la nube. Actualmente en beta abierta, Endurance se convertirá en una oferta comercial completa a finales de 2024.',
    'adc_add_message_enterprise': 'Loadbalancer Enterprise está diseñado para ser inteligente, no complejo, con opciones de despliegue y pago flexibles. Estos ADCs totalmente equipados ofrecen el mayor rendimiento y fiabilidad inigualable para cargas de trabajo críticas.',
    'adc_add_message_f5': 'F5 es una empresa de servicios y seguridad de aplicaciones en múltiples nubes, comprometida con llevar a la vida un mundo digital mejor. Aunque han diversificado su gama de productos, su balanceador de carga BIG-IP sigue siendo una parte central de su oferta.',
    'adc_add_message_generic': 'Un dispositivo genérico es un componente en una configuración de red, que ofrece conectividad básica y capacidades de transmisión de datos. Generalmente incluye características como enrutamiento, conmutación y seguridad básica de red, sirviendo como una herramienta versátil para establecer y gestionar conexiones de red.',
    'adc_add_message_kemp': 'Los ADCs Progress Kemp LoadMaster están diseñados para optimizar una amplia gama de aplicaciones con plantillas y soporte para servidores de aplicaciones web, incluyendo SSL y HTTP/2, aplicaciones de Microsoft y mucho más.',
    'adc_add_message_shuttle_endurance': 'La última versión de nuestro software de equilibrio de carga.',
    'adc_add_message_shuttle_enterprise': 'Solución poderosa y altamente personalizable que incluye configuración automatizada, enrutamiento y almacenamiento en caché de contenido, DSR, conmutación de contenido en la capa 7, etiquetado VLAN y muchas otras características.',
    'adc_add_message_shuttle_stand_alone': 'Un Shuttle independiente es un proxy sidecar liviano diseñado para conectar sin problemas su red local o en la nube con nuestra plataforma SaaS. Al enrutar el tráfico de forma segura a través del transbordador, sus ADC pueden conectarse a nuestros servicios sin una configuración compleja ni exposición directa a la Internet pública, lo que garantiza una integración optimizada y segura.',
    'adc_add_message_shuttle_token': 'Configuración tokenizada próximamente.',
    'adc_add_message_shuttle_virtual_machine': 'Está utilizando una de nuestras máquinas virtuales para crear un shuttle.',
    'adc_add_optional_info': 'Información adicional (Opcional)',
    'adc_add_ready_to_connect': 'Listo para conectar',
    'adc_add_ready_to_connect_message': 'Por favor, verifica tus ajustes. Puedes editar tus detalles o presionar el botón de enviar abajo cuando estés listo. Si la conexión es exitosa, verás tu dispositivo adoptado en tu lista de ADC.',
    'adc_add_schedule': 'Agregar horario',
    'adc_add_shuttle_details': 'Detalles del transbordador',
    'adc_backup_now': 'Respaldar ahora',
    'adc_backups_view_list': 'Ver respaldos',
    'adc_data_no_notes': 'No se han añadido notas',
    'adc_data_no_tags': 'No se han añadido etiquetas',
    'adc_direct_access': 'Acceso directo a ADC',
    'adc_direct_access_short': 'Acceso directo',
    'adc_download_success': 'Descarga de la plataforma completada exitosamente',
    'adc_duplicate_ip_message': 'Esta dirección IP entra en conflicto con otro ADC que está utilizando esta combinación de IP y puerto.',
    'adc_edit': 'Editar ADC',
    'adc_edit_details': 'Editar detalles del ADC',
    'adc_edit_lock': 'Bloquear ADC',
    'adc_edit_lock_message': 'Bloquea tu ADC para evitar cambios o eliminación.',
    'adc_empty_no_shuttle_message': 'El Portal utiliza Shuttle (agente Sidecar) para ayudarlo a administrar sus ADC. Para configurar un nuevo ADC, primero agregue un Shuttle en ',
    'adc_empty_shuttle_message': 'Tienes ',
    'adc_empty_shuttle_message_2': 'Shuttles disponibles, ahora puedes usarlos para',
    'adc_empty_shuttle_message_3': 'agregar un ADC',
    'adc_empty_shuttle_message_4': 'a tu red.',
    'adc_empty_shuttle_title': 'Listo para agregar tu ADC.',
    'adc_empty_no_shuttle_title': 'No hay lanzaderas en este espacio de nombres.',
    'adc_generic_message': 'Asegúrate de tener acceso a este ADC genérico.',
    'adc_go_to': 'Ir a ADC',
    'adc_ha_status': 'Estado de alta disponibilidad',
    'adc_ip_out_of_range': 'Esta dirección IP está fuera del rango del Shuttle seleccionado.',
    'adc_locked': 'Bloqueado',
    'adc_name': 'Nombre del ADC',
    'adc_new_version': 'Nueva versión',
    'adc_no-warp_message': 'El acceso remoto para este dispositivo está actualmente no disponible.',
    'adc_offline_message': 'Este ADC no está actualmente en línea.',
    'adc_pending_adoption': 'Adopción pendiente',
    'adc_pending_adoption_message': 'Este ADC está adjunto a un transbordador que está pendiente de adopción, ¿quieres vincular a la página del transbordador?',
    'adc_port_clashes_with_another_ADC': 'Este puerto entra en conflicto con otro ADC que está utilizando esta combinación de puerto e IP.',
    'adc_remove': 'Eliminar ADC',
    'adc_remove_message': '¿Estás seguro de que quieres eliminar este ADC de tu organización?',
    'adc_running_status': 'Estado de ejecución',
    'adc_security_message': 'Todo bien, nada que reseñar aquí..',
    'adc_security_message_not_supported': 'Los detalles de seguridad de este proveedor no son compatibles actualmente.',
    'adc_setup_appliance_message': 'Por favor, ve a tu descarga y configúrala para balanceo de carga.',
    'adc_setup_connected_message': '¡Felicidades! Tu dispositivo ADC ha sido configurado y está listo para ser adoptado. Ve a la Lista de ADC del Portal de Balanceador de Carga y presiona el botón de Adoptar.',
    'adc_setup_connected_title': 'Dispositivo listo para ser adoptado',
    'adc_setup_help_prompt_message': '¿Necesitas ayuda para configurar tu portal? ¡Habla con uno de nuestros equipos de soporte!',
    'adc_setup_shuttle': 'Configurar Shuttle',
    'adc_setup_skip_to_overview': 'Saltar a Visión general',
    'adc_setup_successful_message': 'Shuttle configurado exitosamente',
    'adc_shuttle_add': 'Agregar Shuttle',
    'adc_shuttle_adoption': 'Adopción lanzadera',
    'adc_shuttle_associate': 'ADC asociado',
    'adc_shuttle_associated': 'ADCs asociados',
    'adc_shuttle_associated_none': 'No hay ADCs asociados',
    'adc_shuttle_button_message': 'Volver a la lista de lanzaderas',
    'adc_shuttle_confirm_adc': 'Confirmar credenciales del ADC',
    'adc_shuttle_confirm_adc_message': 'Parece que estás intentando adoptar un transbordador de un dispositivo de loadbalancer.org. Por favor, introduce tus credenciales de ADC para que podamos agregarlo automáticamente por ti.',
    'adc_shuttle_edit': 'Editar Shuttle',
    'adc_shuttle_edit_lock': 'Bloquear Shuttle',
    'adc_shuttle_edit_lock_message': 'Bloquea tu Shuttle para evitar cambios o eliminación.',
    'adc_shuttle_edit_subnet_delete_message': '¿Estás seguro de que quieres eliminar esta subred?',
    'adc_shuttle_edit_subnet_existing_gateway': 'Usar puerta de enlace existente',
    'adc_shuttle_edit_subnet_new_gateway': 'Crear nueva puerta de enlace',
    'adc_shuttle_existing': 'Agregar Shuttle existente',
    'adc_shuttle_incoming_message': 'Estos transbordadores se agregaron en los últimos segundos.',
    'adc_shuttle_incoming_message_2': 'NOTA: ¡Es posible que estos no sean los transbordadores que está buscando!',
    'adc_shuttle_incoming_message_3': 'No puedo ver tu transporte en la lista',
    'adc_shuttle_intercom_message': 'He completado los pasos en la página \'Agregar lanzadera\' pero no puedo ver mi lanzadera',
    'adc_shuttle_management': 'Gestión de Shuttles',
    'adc_shuttle_name': 'Nombre del Shuttle',
    'adc_shuttle_new': 'Agregar nuevo Shuttle',
    'adc_shuttle_new_message': 'Un Shuttle es un agente de sidecar que crea un canal de comunicación entre el Portal y los ADC disponibles en tu red.',
    'adc_shuttle_new_message_2': 'Para agregar y administrar un ADC en el Portal, primero debes agregar un Shuttle.',
    'adc_shuttle_new_title': '¿Qué es un Shuttle?',
    'adc_shuttle_no_associated_adcs': 'No hay ADC que asociados con este transbordador.',
    'adc_shuttle_remove': 'Eliminar Shuttle',
    'adc_shuttle_remove_message': '¿Estás seguro de que quieres eliminar este Shuttle de tu organización?',
    'adc_shuttle_skip-adoption': 'Saltar adopción de ADC',
    'adc_shuttle_token_linux': 'entorno linux',
    'adc_shuttle_token_linux_message': 'El script de shell de Shuttle funciona en Linux, simplemente copie el token en su terminal y ejecútelo. Instalará automáticamente todos los recursos necesarios.\n',
    'adc_shuttle_token_message': 'Copie el siguiente token y ejecútelo en el entorno de shell de su balanceador de carga:',
    'adc_shuttle_token_message_standalone': 'Copie el siguiente token y ejecútelo en su entorno de shell:',
    'adc_shuttle_token_requirements': 'Requisitos',
    'adc_shuttle_token_requirements_message': 'Asegúrese de que lo siguiente esté instalado en su entorno:',
    'adc_shuttle_update': 'Actualizar Shuttle',
    'adc_shuttle_waiting': 'esperando el transbordador',
    'adc_this_cant_message': 'Esta acción no se puede completar en este momento o no tienes permiso',
    'adc_update_disabled': 'Este ADC no admite actualizaciones a través del portal.',
    'adc_update_error': 'Error al actualizar este ADC. Por favor, contacta al soporte o intenta de nuevo en unos minutos.',
    'adc_update_now': 'Actualizar ahora',
    'adc_view_schedules': 'Ver horarios',
    'adc_view_security_risks': 'Ver riesgos de seguridad',
    'adc_waiting_for_shuttle': 'Esperando configuración del transbordador...',
    'adc_warp_to_adc': 'Ir a ADC',
    'adc_warp_vendor_not_included': 'Warp no está disponible actualmente para este proveedor',
    'adc_widget_connections': 'Conexiones de ADC utilizadas',
    'admin_panel': 'Administrador del portal',
    'advanced_services': 'Servicios avanzados',
    'advanced_services_advanced_stats': 'Estadísticas avanzadas',
    'advanced_services_buffer_size': 'Tamaño del búfer',
    'advanced_services_client_timeout': 'Tiempo de espera del cliente',
    'advanced_services_conn_timeout': 'Tiempo de espera de conexión',
    'advanced_services_email_alert_from': 'Alerta de correo electrónico de',
    'advanced_services_email_alert_to': 'Alerta de correo electrónico a',
    'advanced_services_email_alerts': 'Alertas de correo electrónico',
    'advanced_services_email_server_addr': 'Dirección del servidor de correo electrónico',
    'advanced_services_email_server_port': 'Puerto del servidor de correo electrónico',
    'advanced_services_enable_multi_thread': 'Habilitar multiprocesamiento',
    'advanced_services_enable_ssl': 'Habilitar SSL',
    'advanced_services_enable_stats': 'Habilitar página de estadísticas',
    'advanced_services_haproxy_stats_advanced': 'Estadísticas avanzadas de HAProxy',
    'advanced_services_hdr_buf_len': 'Longitud del búfer de encabezado',
    'advanced_services_logging': 'Registro',
    'advanced_services_multi_thread': 'Multiprocesamiento',
    'advanced_services_no_of_threads': 'Número de procesos',
    'advanced_services_persist_repl_port': 'Puerto de replicación de persistencia',
    'advanced_services_persist_replication': 'Habilitar replicación de persistencia',
    'advanced_services_persistence_table': 'Replicación de tabla de persistencia',
    'advanced_services_real_server_timeout': 'Tiempo de espera de respuesta del servidor real',
    'advanced_services_req_buf_len': 'Longitud del búfer de solicitud',
    'advanced_services_ssl_cache_options': 'Opciones de caché SSL',
    'advanced_services_ssl_cache_size': 'Tamaño de la caché SSL',
    'advanced_services_statistics_page': 'Página de estadísticas',
    'app_overlay_message': 'Funciona mejor en una pantalla más grande',
    'auditing': 'Auditoría',
    'auditing_activity_type': 'Tipo de actividad',
    'auditing_session_log': 'Registro de sesión',
    'auditing_session_time': 'Tiempo de sesión',
    'auditing_upgrade_message': 'Mejora la seguridad de tu organización utilizando Auditoría para el acceso a tu portal. ¡Es bueno!',
    'auditing_upgrade_title': 'Actualiza para usar Auditoría',
    'backup_download_message': 'Por favor, ingrese su contraseña para desencriptar esta copia de seguridad.',
    'backup_for': 'Copia de seguridad para',
    'backup_restore': 'Copia de seguridad y restauración',
    'backup_restore_auto_backup': 'Copia de seguridad automática',
    'backup_restore_download_complete': 'Descarga de copia de seguridad completa',
    'backup_restore_make_fip_active': 'Activar',
    'backup_restore_node_name': 'Nombre del nodo',
    'backup_restore_restore_from': 'Restaurar desde copia de seguridad',
    'backup_restore_restore_model_text': 'La caja se está restaurando. Se cerrará la sesión y se recargará en',
    'backup_restore_select_node_message': 'Por favor, seleccione restaurar desde un nodo o una parte.',
    'backup_restore_select_section_message': 'Puede seleccionar elementos individuales para restaurar',
    'backup_restore_select_type': 'Tipo de restauración',
    'backup_restore_upload_backup': 'Subir copia de seguridad',
    'backup_restore_uploaded_backups': 'Copias de seguridad subidas',
    'backup_widget_backups_used': 'copias de seguridad utilizadas',
    'billing_adc_pack': 'Extras',
    'billing_portal': 'Niveles',
    'billing_add_payment_method': 'Agregar nuevo método de pago',
    'billing_address': 'Dirección de Envio',
    'billing_amount': 'Cantidad',
    'billing_bad_debt': 'Deuda incobrable',
    'billing_cancel_plan': 'Cancelar plan',
    'billing_card_cvc': 'CVC',
    'billing_card_details': 'Detalles de la tarjeta',
    'billing_card_ending': 'final de tarjeta...',
    'billing_card_name': 'Nombre en la tarjeta',
    'billing_card_number': 'Número de tarjeta',
    'billing_card_selected': 'Tarjeta seleccionada',
    'billing_contact': 'Contactar facturación',
    'billing_date': 'Fecha de facturación',
    'billing_draft': 'Borrador',
    'billing_edit_payment_method': 'Editar método de pago',
    'billing_email_address': 'Dirección de correo electrónico de facturación',
    'billing_edit_subscription': 'Editar suscripción',
    'billing_expiry': 'Vencimiento',
    'billing_invoice': 'Factura',
    'billing_invoice_history': 'Historial de facturas',
    'billing_item': 'Artículo',
    'billing_items': 'Artículos de facturación',
    'billing_make_default': 'Hacer predeterminado',
    'billing_monthly_cost': 'Costo mensual',
    'billing_name': 'Nombre de facturación',
    'billing_paid': 'Pagado',
    'billing_payment_method': 'Método de pago',
    'billing_payment_methods': 'Métodos de pago',
    'billing_payment_status': 'Estado de envío de pago',
    'billing_remove_payment': 'Eliminar método de pago',
    'billing_remove_payment_message': '¿Estás seguro de que deseas eliminar este método de pago?',
    'billing_remove_subscription': 'Cancelar suscripción',
    'billing_remove_subscription_hint': 'Suscripción ya cancelada',
    'billing_remove_subscription_message': '¿Estás seguro de que deseas cancelar esta suscripción?',
    'billing_waiting_payment': 'Esperando pago',
    'certificate_add_ca': 'Agregar CA',
    'certificate_add_certificate': 'Agregar certificado',
    'certificate_add_crl': 'Agregar CRL',
    'certificate_apply_csr': 'Aplicar CSR',
    'certificate_common_name': 'Nombre común',
    'certificate_country': 'País',
    'certificate_country_code': 'Código del país',
    'certificate_create_cert': 'Crear certificado',
    'certificate_create_csr': 'Crear CSR',
    'certificate_create_self-signed': 'Crear autofirmado',
    'certificate_csr': 'Solicitud de certificado',
    'certificate_csrs_subject_alt': 'Alt(s) del sujeto',
    'certificate_counter_label_total': 'Certificados totales',
    'certificate_counter_label_expiring': 'Vencimiento (30 días)',
    'certificate_counter_label_expired': 'Certificados caducados',
    'certificate_counter_none': 'No hay certificados disponibles.',
    'certificate_counter_none_message': 'Todos los certificados de seguridad asociados con sus ADC se mostrarán aquí.',
    'certificate_details': 'Detalles del certificado',
    'certificate_domain_cn': 'Dominio (CN)',
    'certificate_edit_ca': 'Editar CA',
    'certificate_edit_cert': 'Editar certificado',
    'certificate_edit_certificate': 'Editar certificado',
    'certificate_edit_crl': 'Editar CRL',
    'certificate_edit_csr': 'Editar CSR',
    'certificate_expired_today': 'Expirado hoy',
    'certificate_expired_x_days_ago': 'Caducó hace {{placeholder}} días',
    'certificate_expires_x_days': 'Caduca en {{placeholder}} días',
    'certificate_input_subject_alt': 'subjectAlt',
    'certificate_inter_certs': 'Certificado intermedio',
    'certificate_invalid_email': 'Correo electrónico inválido',
    'certificate_issuer': 'Editor',
    'certificate_key_length': 'Longitud de la clave CSR',
    'certificate_locality': 'Localidad (L)',
    'certificate_name': 'Nombre del certificado',
    'certificate_organization': 'Organización (O)',
    'certificate_organizational_unit': 'Unidad organizativa (OU)',
    'certificate_private_key': 'Clave privada',
    'certificate_root_cert': 'Certificado raíz',
    'certificate_san_label': 'Nombre(s) alternativo(s) del sujeto (SAN)',
    'certificate_select_cert': 'Seleccionar certificado',
    'certificate_self_signed': 'Autofirmado',
    'certificate_signature_algorithm': 'Algoritmo de firma',
    'certificate_state_st': 'Estado o provincia (ST)',
    'certificate_subject_alt': 'Alt del sujeto (SAN)',
    'certificate_view_csr': 'Ver CSR',
    'checkout_cart': 'Carro',
    'checkout_cart_add_hint_test': 'No puedes tener más de un nivel de suscripción.',
    'checkout_cart_empty_message': 'Tu carrito está vacío',
    'checkout_cart_max-items_message': 'Has alcanzado el número máximo de artículos en el carrito.',
    'checkout_interval_hint_test': 'No puedes mezclar tipos de suscripción',
    'checkout_select_payment_card': 'Selecciona el método de pago',
    'checkout_select_product': 'Seleccionar producto',
    'checkout_selected_payment_card': 'Método de pago seleccionado',
    'checkout_selected_product': 'Producto seleccionado',
    'cipher_list_available': 'Cifras disponibles',
    'cipher_list_create_new': 'Agregar nueva cifra',
    'cipher_list_delete_cipher': 'Eliminar cifra',
    'cipher_list_edit_cipher': 'Editar cifra',
    'cipher_list_name': 'Nombre de la lista',
    'cipher_list_new': 'Nueva lista de cifras',
    'cipher_list_selected': 'Cifras seleccionadas',
    'cipher_list_title': 'Listas de cifras SSL',
    'cipher_list_tls_version': 'Versión TLS',
    'cipher_list_view': 'Ver lista de cifras',
    'confirm_logout': '¿Está seguro de que desea cerrar sesión?',
    'create_bond_available_interfaces': 'Interfaces disponibles',
    'create_bond_bond_name': 'Nombre del enlace',
    'create_bond_eth_brackets': '(eth)',
    'create_bond_help_text': 'Haga clic en dos o más interfaces para enlazar',
    'create_bond_no_interfaces_found': 'No se encontraron interfaces.',
    'create_bond_please_return_to': 'Por favor, regrese a',
    'csv_importer_title': 'Asignar columnas a campos',
    'csv_importer_description': 'En este modal, debe asignar los encabezados CSV a los campos de envío correspondientes. Todos los campos obligatorios deben coincidir antes de poder enviar. Una vez enviado correctamente, cada usuario recibirá un correo electrónico con un enlace de activación. Se le pedirá que ingrese su nombre y cree una contraseña. Después de configurar su contraseña, los usuarios deben descargar una copia de su clave de usuario privada y guardarla en un lugar seguro por si se recupera la cuenta.',
    'csv_importer_missing_fields': 'Campos obligatorios faltantes:',
    'csv_importer_missing_fields_set': 'Número de campos obligatorios establecidos:',
    'csv_importer_heading_csv_headings': 'Encabezados CSV',
    'csv_importer_heading_submission_headings': 'Propiedades de envío',
    'csv_importer_number_records': 'Número de registros:',
    'csv_importer_preview': 'Avance',
    'csv_importer_import_users': 'Importar usuarios',
    'csv_importer_switch_view_errors': 'Ver errores',
    'csv_importer_switch_view_results': 'Ver resultados',
    'dashboard_advert_boost_title': 'Mejora tu experiencia ADC con nuevas funciones',
    'dashboard_advert_demo_title': '¿Necesitas ayuda? Programa una demostración gratuita con un ingeniero de Portal',
    'dashboard_advert_trial_title': 'Prueba nuestro balanceador de carga con todas las funciones gratis por 30 días',
    'dashboard_features': 'Características',
    'dashboard_guides': 'Guías',
    'dashboard_quick_links': 'Enlaces rápidos',
    'dashboard_whats_new': 'Portal: Novedades',
    'date_time_current_sys_time': 'Hora actual del sistema',
    'date_time_date_out_of_range_license_text': 'Advertencia: su fecha está fuera del período de licencia actual. Al cambiar su fecha, invalidará su licencia. ¿Está seguro de que desea continuar?',
    'date_time_date_out_of_range_license_title': 'Advertencia de licencia',
    'date_time_date_out_of_range_relogin_text': 'Advertencia: su fecha y hora están configuradas en un momento futuro. Es posible que se le pida que vuelva a iniciar sesión.',
    'date_time_date_out_of_range_relogin_title': 'Advertencia de fecha',
    'date_time_ntp_server_1': 'servidor ntp 1',
    'date_time_ntp_server_2': 'servidor ntp 2',
    'date_time_ntp_server_3': 'servidor ntp 3',
    'date_time_ntp_servers': 'Servidores NTP',
    'date_time_set_date_time': 'Configurar fecha y hora',
    'date_time_set_manually': 'Configurar fecha y hora manualmente',
    'date_time_set_ntp': 'Configurar NTP',
    'date_time_set_timezone': 'Configurar zona horaria',
    'date_time_sys_timezone': 'Zona horaria del sistema',
    'date_time_use_ntp_servers': 'Usar servidores NTP',
    'error_page_title': 'esta página no está disponible',
    'error_page_message': 'Estamos trabajando para solucionarlo.',
    'execute_command_common': 'Comandos comunes',
    'execute_command_input': 'Entrada de comando',
    'execute_shell_command': 'Ejecutar comando de shell',
    'external_all_rights_reserved': 'Todos los derechos reservados',
    'external_link': 'Enlace externo',
    'fallback_add': 'Agregar servidor de respaldo',
    'fallback_masq': 'Respaldo MASQ',
    'fallback_page_edit': 'Editar página de respaldo',
    'fallback_pages': 'Páginas de respaldo',
    'fallback_pages_add_page': 'Agregar página de respaldo',
    'fallback_pages_delete_page': 'Eliminar página',
    'fallback_pages_delete_page_message': '¿Está seguro de que desea eliminar las páginas de respaldo?',
    'fallback_pages_page_content': 'Contenido de la página',
    'fallback_pages_usage': 'Uso de página de respaldo',
    'fallback_server': 'Servidor de respaldo',
    'floating_ip': 'IP flotante',
    'floating_ip_add': 'Agregar IP flotante',
    'floating_ip_all_disable': 'Desactivar todas las IP flotantes',
    'floating_ip_all_enable': 'Activar todas las IP flotantes',
    'floating_ip_change': 'IP cambiada',
    'floating_ip_change_message': 'La IP que está cambiando está asignada a un servicio y ese servicio necesitará ser recargado',
    'floating_ip_delete_message': 'Se han eliminado todas las IP flotantes seleccionadas que no están en uso.',
    'floating_ip_delete_multiple_ips': 'Eliminar múltiples IPs',
    'floating_ip_delete_selected': 'Eliminar IPs flotantes seleccionadas',
    'floating_ip_deleting_multiple_ip': 'Eliminar IP',
    'floating_ip_disable': 'Desactivar IP flotante',
    'floating_ip_disable_selected': 'Desactivar IPs flotantes seleccionadas',
    'floating_ip_edit': 'Editar IP flotante',
    'floating_ip_enable': 'Activar IP flotante',
    'floating_ip_enable_selected': 'Activar IPs flotantes seleccionadas',
    'floating_ip_in_use': 'En uso',
    'floating_ip_usage': 'Uso de IP flotante',
    'floating_ip_usage_for_ip': 'Uso para IP',
    'free_trial_step_1_button': 'Comenzar',
    'free_trial_step_1_intro': 'Su prueba es una versión completamente sin restricciones de nuestro Enterprise VA Max y es gratuita para usar durante 30 días. Si necesita una extensión de la prueba, contáctenos.',
    'free_trial_step_1_simple_steps': 'Pasos simples:',
    'free_trial_step_1_step_message_1': 'Elija su hipervisor y descargue.',
    'free_trial_step_1_step_message_2': 'Si necesita ayuda durante su prueba gratuita de ADC, tendrá acceso completo a nuestro soporte 24/7',
    'free_trial_step_1_step_message_3': 'Regístrese para la prueba gratuita de ADC Portal - nuestro nuevo sistema de gestión centralizado',
    'free_trial_step_1_title': 'Comencemos con su prueba gratuita de Enterprise ADC.',
    'free_trial_step_2_intro': 'Seleccione su hipervisor preferido de la lista a continuación. Nuestro balanceador de carga puede funcionar en una variedad de otros hipervisores, si el suyo no está en la lista, contáctenos y le ayudaremos.',
    'free_trial_step_2_min_spec': 'CPU de 64 bits, soporte de hardware de tecnología virtual (CPU compatibles con Intel-VT-x o AMD-V). De manera predeterminada, la aplicación virtual se asigna con 2 vCPUs, 4 GB de RAM y tiene un disco virtual de 20 GB, que debería ser adecuado para aplicaciones de producción de rendimiento bajo a medio. (Pueden aumentarse según sea necesario)',
    'free_trial_step_2_title': 'Elija su hipervisor.',
    'free_trial_step_3_button': 'Echar un vistazo al Portal',
    'free_trial_step_3_intro': 'Gracias por descargar su prueba gratuita de Enterprise ADC. Ahora está listo para configurar la aplicación en su máquina virtual.',
    'free_trial_step_3_intro_2': 'La guía de inicio rápido (incluida en su descarga) lo guiará a través de los pasos de configuración, pero si necesita más ayuda, contáctenos.',
    'free_trial_step_3_intro_3': 'Otros usuarios encuentran beneficioso utilizar nuestro nuevo ADC Portal — ya le hemos creado una cuenta, simplemente actívela para comenzar a explorarlo de forma gratuita.',
    'free_trial_step_3_quick_start': 'Guía de inicio rápido',
    'free_trial_step_3_title': 'Gracias.',
    'free_trial_step_3_title_2': 'Pruebe el nuevo Portal de Loadbalancer ADC',
    'free_trial_step_4_button_action_later': 'Lo haré más tarde',
    'free_trial_step_4_button_activate_trial': 'Activar mi prueba gratuita de Portal',
    'free_trial_step_4_intro': 'El Portal de Loadbalancer ADC es una plataforma intuitiva pero completa que permite la automatización, orquestación, gestión y análisis para la entrega de aplicaciones en entornos locales, en la nube, híbridos y multicloud.',
    'free_trial_step_4_step_message_1': 'Consolide todos sus dispositivos en un único panel.',
    'free_trial_step_4_step_message_2': 'Cree flujos de trabajo automatizados para permitir tareas comunes de ADC.',
    'free_trial_step_4_step_message_3': 'Seguridad completa de extremo a extremo, utilizando tecnología criptográfica de vanguardia.',
    'free_trial_step_4_title': 'Portal de Loadbalancer ADC',
    'free_trial_step_5_button_schedule_demo': 'Programar demostración',
    'free_trial_step_5_button_skip': 'Omitir y finalizar',
    'free_trial_step_5_intro': '¿Necesita ayuda para configurar su dispositivo ADC? ¿Por qué no programa una demostración o una llamada de soporte con uno de nuestros ingenieros? Puede reservar una reunión en la fecha y hora que más le convenga haciendo clic en el botón a continuación.',
    'free_trial_step_5_intro_2': 'Alternativamente, se incluye soporte 24/7 durante la duración de su prueba gratuita y nuestro equipo puede ser contactado por correo electrónico',
    'free_trial_step_5_intro_3': 'a través del chat en línea o completando un ticket de soporte -',
    'free_trial_step_5_title': '¿Necesita ayuda? ¿Por qué no programa una demostración?',
    'gslb_add_global_name': 'Agregar nombre global',
    'gslb_add_global_names': 'Agregar nombres globales',
    'gslb_add_member': 'Agregar miembro',
    'gslb_add_pool': 'Agregar pool',
    'gslb_add_topology': 'Agregar topología',
    'gslb_available_members': 'Miembros disponibles',
    'gslb_delete_global_name': 'Eliminar nombre global',
    'gslb_delete_member': 'Eliminar miembro',
    'gslb_delete_pool': 'Eliminar pool',
    'gslb_delete_topology': 'Eliminar topología',
    'gslb_edit_global_name': 'Editar nombre global',
    'gslb_edit_member': 'Editar miembro',
    'gslb_edit_pool': 'Editar pool',
    'gslb_edit_topology': 'Editar topología',
    'gslb_global_name': 'Nombre global',
    'gslb_global_names': 'Nombres globales',
    'gslb_global_services': 'Servicio global',
    'gslb_healthcheck_expected_codes': 'Códigos esperados del monitor',
    'gslb_healthcheck_hostname': 'Nombre del host del monitor',
    'gslb_healthcheck_interval': 'Intervalo del monitor',
    'gslb_healthcheck_ip': 'IP del monitor',
    'gslb_healthcheck_match_re': 'Monitor coincidir RE',
    'gslb_healthcheck_mode': 'Modo de monitor',
    'gslb_healthcheck_no_scripts_found': 'No se encontraron scripts de verificación de salud',
    'gslb_healthcheck_port': 'Puerto del monitor',
    'gslb_healthcheck_retries': 'Reintentos del monitor',
    'gslb_healthcheck_script': 'Script del monitor',
    'gslb_healthcheck_send_string': 'Cadena de envío del monitor',
    'gslb_healthcheck_status': 'Estado del monitor',
    'gslb_healthcheck_timeout': 'Tiempo de espera del monitor',
    'gslb_healthcheck_type': 'Tipo de monitor',
    'gslb_healthcheck_url_path': 'Ruta de URL del monitor',
    'gslb_healthcheck_use_ssl': 'Monitor usar SSL',
    'gslb_ip_subnet': 'Subred IP',
    'gslb_lb_method': 'Método LB',
    'gslb_max_address_returned': 'Máxima dirección devuelta',
    'gslb_no_available_global_names': 'No hay nombres globales disponibles',
    'gslb_no_data_gslb_pools': 'Actualmente no se están recopilando datos para los pools de GSLB.',
    'gslb_no_members': 'No hay miembros',
    'gslb_no_members_text': 'No ha configurado ningún miembro. Se requieren miembros para crear una topología.',
    'gslb_pools_input_monitorCode': 'Código de monitor',
    'gslb_refuse_on_failure': 'Rechazar el fracaso',
    'gslb_report_distribution': 'Informe de estado de distribución de GSLB',
    'gslb_report_distribution_error': 'Los datos del estado de distribución de GSLB no están disponibles',
    'gslb_report_health_check': 'Informe de verificación de salud de GSLB',
    'gslb_report_health_check_error': 'Los datos de verificación de salud de GSLB no están disponibles',
    'gslb_return_to_gslb_page': 'Volver a la página de GSLB',
    'gslb_selected_members': 'Miembros seleccionados',
    'gslb_time_to_live': 'Tiempo de vida',
    'ha_conf': 'Configuración de alta disponibilidad',
    'ha_conf_add_node': 'Agregar nodo',
    'ha_conf_administrator_email': 'Correo electrónico del administrador*',
    'ha_conf_administrator_password': 'Contraseña del administrador*',
    'ha_conf_bind_address': 'Dirección de enlace',
    'ha_conf_confirm_service_restart': 'Confirmar reinicio del servicio',
    'ha_conf_confirm_service_restart_message': 'Está reiniciando un servicio en un nodo diferente al que está conectado actualmente.',
    'ha_conf_join': 'Unirse a alta disponibilidad',
    'ha_conf_join_confirmation': 'Confirmación de agregar alta disponibilidad',
    'ha_conf_join_confirmation_message': 'Por favor confirme que desea continuar agregando el nodo ya que este proceso borrará la configuración de sus pares.',
    'ha_conf_last_health_check': 'Última verificación de estado',
    'ha_conf_latency': 'Latencia',
    'ha_conf_peer_ip_address': 'Dirección IP del par*',
    'ha_conf_peer_port': 'Puerto del par*',
    'ha_conf_promote': 'Promover',
    'ha_conf_re_sync_config': 'Re-sincronizar configuración',
    'ha_conf_reload_restart_services': 'Recargar/Reiniciar servicios',
    'ha_conf_remove_node_title': 'Eliminar nodo',
    'ha_conf_remove_node_message': '¿Está seguro de que desea eliminar este nodo?',
    'ha_conf_restore_confirmation': 'Confirmar restauración del nodo',
    'ha_conf_restore_confirmation_message': 'Por favor confirme que desea restaurar el nodo.',
    'ha_conf_restore_node': 'Restaurar nodo',
    'ha_conf_services_message': 'Es necesario reiniciar algunos servicios antes de poder agregar un nodo. Asegúrese de que el otro nodo esté actualizado y que los servicios requeridos se estén ejecutando.',
    'ha_conf_services_unavailable': 'Servicios no disponibles',
    'hanging_acl_delete': 'Eliminar ACL',
    'hanging_acl_deleted_all': 'Todas las ACL pendientes eliminadas',
    'hanging_acl_deleting': 'Eliminando ACL pendiente',
    'hanging_acls': 'ACLs pendientes',
    'hanging_acls_acls_list': 'A continuación se muestra una lista de ACLs que no están asociadas a un frontend.',
    'hanging_acls_deleted_all': 'Todas las ACLs pendientes eliminadas',
    'hanging_acls_deleting': 'Eliminando ACLs pendientes',
    'hanging_backend_delete': 'Eliminar Backend',
    'hanging_backend_delete_message': '¿Estás seguro de que quieres eliminar el backend?',
    'hanging_backend_delete_message_multiple': '¿Estás seguro de que deseas eliminar los backends colgantes seleccionados?',
    'hanging_backend_delete_selected': 'Eliminar los backends colgantes seleccionados',
    'hanging_backend_deleted_all': 'Todos los backends pendientes eliminados',
    'hanging_backend_deleting': 'Eliminando backend pendiente',
    'hanging_backend_real_servers_usage': 'Uso de servidores reales',
    'hanging_backends': 'Backends pendientes',
    'hanging_backends_backends_info': 'Puede crear reglas para asignarlos o eliminarlos',
    'hanging_backends_backends_list': 'A continuación se muestra una lista de backends que no están asociados a un frontend.',
    'hanging_backends_create_acl': 'Crear ACL',
    'hanging_backends_deleting': 'Eliminando backends pendientes',
    'hanging_backends_usage_for_backend': 'Uso de servidores reales para backend pendiente',
    'hanging_backends_usage_real_server_address': 'Dirección de servidores reales',
    'hanging_backends_usage_real_server_label': 'Etiqueta de servidores reales',
    'hanging_groups_assign': 'Asignar grupos pendientes',
    'hanging_groups_remote_node': 'Esta asignación está en un nodo remoto',
    'hanging_real_assign': 'Asignar servidores reales',
    'hanging_real_assign_backend': 'Asignar a un backend',
    'hanging_real_assign_backend_count': 'Servidores disponibles',
    'hanging_real_assign_confirm_message_multiple': '¿Está seguro de que desea asignar los servidores reales seleccionados a los backends seleccionados?',
    'hanging_real_assign_confirm_message_single': '¿Estás seguro de que quieres asignar un servidor real?',
    'hanging_real_assign_no_backend_message': 'No hay backends coincidentes',
    'hanging_real_assigned_all': 'Todos los servidores reales colgantes seleccionados asignados',
    'hanging_real_delete': 'Eliminar servidor real',
    'hanging_real_delete_all': 'Eliminar todos los servidores reales colgados',
    'hanging_real_delete_confirm_message_multiple': '¿Estás seguro de que deseas eliminar los servidores reales colgados seleccionados?',
    'hanging_real_delete_confirm_message_single': '¿Estás seguro de que deseas eliminar el servidor real ',
    'hanging_real_deleting': 'Eliminar servidor real colgado',
    'hanging_reals': 'Colgando servidores reales',
    'hanging_reals_deleted_all': 'Se eliminaron todos los servidores reales colgados',
    'hanging_reals_deleting': 'Eliminar servidores reales colgados',
    'hanging_reals_real_servers_usage': 'Uso de servidores reales',
    'hanging_reals_reals_list': 'A continuación se muestra una lista de servidores reales que no están asociados a un servicio.',
    'hanging_reals_usage_real_server_address': 'Dirección de servidores reales',
    'hanging_reals_usage_real_server_label': 'Etiqueta de servidores reales',
    'header_add_header': 'Agregar encabezado',
    'header_edit_header': 'Editar encabezado',
    'header_replace_value': 'Reemplazar valor',
    'health_check': 'Verificación de estado',
    'health_check_add': 'Agregar verificación de estado',
    'health_check_confirm_delete_text': '¿Está seguro de que desea eliminar esta verificación de estado?',
    'health_check_created_by': 'Creado por',
    'health_check_script_content': 'Contenido del script',
    'health_checks': 'Verificaciones de estado',
    'health_checks_radius_secret': 'Secreto de radio',
    'health_checks_usage': 'Uso de verificaciones de estado',
    'host_dns': 'Nombre de host y DNS',
    'host_dns_domain_name_servers': 'Servidores de nombres de dominio',
    'ip_add_group': 'Agregar grupo de IP',
    'ip_delete_group_text': '¿Está seguro de que desea eliminar este grupo?',
    'ip_edit_group': 'Editar grupo de IP',
    'ip_enable_fip': 'Habilitar IP flotante',
    'ip_enable_ipv4': 'Habilitar IPv4',
    'ip_enable_ipv6': 'Habilitar IPv6',
    'ip_go_to_groups': 'Ir a grupos de IP flotantes',
    'ip_group_no_mask_set': 'Sin máscara establecida',
    'ip_groups': 'Grupos de IP',
    'ip_groups_disconnection_warning': ' Asegúrese de que esto sea correcto; de lo contrario, perderá la conexión con su loadbalancer.',
    'ip_groups_gateway_changed': 'Cambio de puerta de enlace predeterminada',
    'ip_groups_gateway_changed_text': 'La puerta de enlace predeterminada se ha cambiado al nuevo grupo de IP',
    // TODO: Remove when IP groups is renamed globally.
    'ip_groups_subnets': 'Grupos de IP (subredes)',
    // TODO: END
    'ip_groups_unassigned_group': 'Grupo no asignado',
    'ip_groups_usage': 'Uso de grupos de IP',
    'ip_hanging_groups': 'Grupos pendientes',
    'ip_ipv4_mask': 'Máscara IPv4',
    'ip_ipv4_mask_upper': 'Máscara IPv4',
    'ip_ipv4_network': 'Red IPv4',
    'ip_ipv4_network_upper': 'Red IPv4',
    'ip_ipv6_mask': 'Máscara IPv6',
    'ip_ipv6_mask_upper': 'Máscara IPv6',
    'ip_ipv6_network': 'Red IPv6',
    'ip_ipv6_network_upper': 'Red IPv6',
    'ip_name_change': 'Nombre del grupo cambiado',
    'ip_name_change_text': 'El nombre del grupo ha cambiado. Esto desactivará y luego activará cualquier IP en este grupo. ¿Desea continuar?',
    'ip_no_ip_config': 'Actualmente no tiene ningún grupo de IP configurado. Para crear una nueva IP flotante, primero cree un nuevo grupo de IP antes de intentar nuevamente.',
    'ip_no_network_set': 'No se ha establecido una red',
    'l7_stick_table': 'Tabla de persistencia de capa 7',
    'l7_stick_table_refresh': 'Actualizar tabla de persistencia',
    'l7_stick_table_select_backend': 'Seleccionar backend:',
    'licence_contact_support': 'Por favor contacte a support@loadbalancer.org.',
    'licence_expiration_due': 'Su soporte vencerá en ',
    'licence_expired_guide': 'Por favor ingrese su nueva clave de licencia o si no tiene una clave de licencia válida por favor contáctenos.',
    'licence_model': 'Modelo',
    'licence_question': '¿Tiene una pregunta sobre licencias?',
    'licence_question_description': 'Tenemos muchas opciones de licencias para adaptarse a las necesidades de su negocio, ¡hable con uno de nuestros amables representantes de ventas hoy!',
    'licence_serial_number': 'Número de serie',
    'licence_support_ends_on': 'El soporte termina en',
    'licence_support_expires_in': 'El soporte vence en ',
    'licence_type': 'Tipo de licencia',
    'licence_update_key': 'Actualizar clave de licencia',
    'licence_widget_core_updates': 'Actualizaciones del núcleo',
    'licence_widget_details': 'Detalles de la licencia',
    'licence_widget_expiry': 'Vencimiento de la licencia',
    'licence_widget_lifetime': '(De por vida)',
    'licence_widget_security_updates': 'Actualizaciones de seguridad',
    'licenced': 'Licenciado',
    'license_expired': 'Su licencia ha expirado',
    'license_update_license_guide': 'Para activar su soporte técnico premium complementario, por favor ingrese una clave de licencia válida. Para obtener su clave de licencia, por favor contáctenos.',
    'license_warn_remaining_days': 'El contrato de soporte para este dispositivo vencerá en ',
    'license_warn_support_expired': 'El contrato de soporte ha expirado en este dispositivo. ',
    'loadbalancer_cluster_configuration': 'Configuración del clúster',
    'loadbalancer_local_config': 'Configuración local',
    'loadbalancer_network': 'Red',
    'loadbalancer_website_link': 'Está a punto de ser dirigido al sitio web de Loadbalancer',
    'login': 'Iniciar sesión',
    'login_connection_settings': 'Configuración de la conexión',
    'login_error': 'Error de inicio de sesión',
    'login_host_ip': 'IP del host',
    'login_invalid_ip': 'IP inválida',
    'login_reset_it': 'Restablézcalo',
    'login_reset_password_message': 'Ingrese su correo electrónico registrado a continuación para recibir instrucciones sobre cómo restablecer su contraseña.',
    'login_untrusted_host_certificate': 'Certificado de host no confiable',
    'login_zero_downtime': 'Tiempo de inactividad cero.',
    'logout_confirmation': 'Confirmación de cierre de sesión',
    'logout_warning_title': 'Advertencia de cierre de sesión',
    'logout_warning_message': 'Se cerrará su sesión en: ',
    'logs_clear_services': 'Limpiar servicios',
    'logs_comm': 'Comm',
    'logs_date_time_format': 'Fecha y hora (yyyy-mm-dd)',
    'logs_error_data': 'Error al recuperar datos de la API, por favor contacte a soporte.',
    'logs_fetching_data': 'Recuperando datos...',
    'logs_log_config': 'Configuración del log',
    'logs_message': 'Mensaje',
    'logs_no_more': 'No hay más logs para mostrar.',
    'logs_pid': 'PID',
    'logs_reverse': 'Reversa',
    'logs_start': 'Iniciar logs',
    'logs_uid': 'UID',
    'manage_acl_rules': 'Administrar reglas de ACL',
    'manage_acls': 'Administrar ACLs',
    'manage_acls_add': 'Agregar ACL',
    'manage_acls_no_frontends_or_backends': 'No se encontraron frontends o backends',
    'manage_acls_no_frontends_or_backends_text': 'Actualmente no tiene frontends o backends, haga clic en confirmar para ser dirigido a la página de administración de servicios, donde puede crear un nuevo servicio.',
    'manage_acls_path_type': 'Tipo de ruta',
    'manage_acls_redirect_location': 'Ubicación de redirección',
    'manage_acls_redirect_type': 'Tipo de redirección',
    'manage_acls_return_to': 'Regresar a Administrar ACLs',
    'manage_services': 'Administrar servicios',
    'manage_services_add_layer_4': 'Agregar servicio de capa 4',
    'manage_services_add_layer_7': 'Agregar servicio de capa 7',
    'manage_services_add_monitor': 'Agregar monitor',
    'manage_services_delete_selected': 'Eliminar frontends seleccionados',
    'manage_services_delete_multiple_frontends': '¿Eliminar varias interfaces?',
    'manage_services_deleting': 'Eliminar interfaces',
    'manage_services_duplicate_monitor': 'Duplicar monitor',
    'manage_services_edit_layer_4': 'Editar servicio de capa 4',
    'manage_services_edit_layer_7': 'Editar servicio de capa 7',
    'manage_services_edit_monitor': 'Editar monitor',
    'manage_services_return': 'Regresar a Administrar servicios',
    'manage_services_view_stick_table': 'Ver tabla de persistencia',
    'missing_ip_add_to_complete': 'Las siguientes direcciones IP deben ser creadas para completar este asistente.',
    'missing_ip_addresses': 'Configuración de IP flotante',
    'missing_ip_status': 'Estado de IP flotante',
    'missing_ip_submit_new_ips': 'Enviar nuevas IPs',
    'mtls_ca': 'Autoridad de Certificación',
    'mtls_crl': 'Lista de Revocación',
    'namespace_add': 'Agregar espacio de nombres',
    'namespace_edit': 'Editar espacio de nombres',
    'namespace_delete': 'Eliminar espacio de nombres',
    'namespace_delete_message': '¿Está seguro de que desea eliminar este espacio de nombres?',
    'namespaces': 'Espacios de nombres',
    'net_int_config': 'Configuración de interfaces',
    'net_int_config_add_interface': 'Agregar interfaz',
    'net_int_config_add_to_bond': 'Agregar a bond',
    'net_int_config_bond_edit': 'Editar bond',
    'net_int_config_break_bond': 'Romper bond',
    'net_int_config_break_bond_backend_message': 'Dejar que el backend asigne automáticamente',
    'net_int_config_break_bond_cancel_text': 'Regresar a configuración de Net-int',
    'net_int_config_break_bond_confirm_message': 'Este bond no tiene grupos y las interfaces serán restauradas a su estado original.',
    'net_int_config_break_bond_groups_message': 'Por favor asigne los grupos de IP de nuevo a las interfaces.',
    'net_int_config_break_bond_vlans_message': 'Por favor asigne vlan de nuevo a las interfaces.',
    'net_int_config_create_bond': 'Agregar Bond',
    'net_int_config_create_bond_message': 'Asigne un nombre a su bond y seleccione las interfaces para enlazar.',
    'net_int_config_delete_vlan': 'Eliminar VLAN',
    'net_int_config_delete_vlan_message': '¿Está seguro de que desea eliminar esta VLAN?',
    'net_int_config_edit_vlan': 'Editar VLAN',
    'net_int_config_interface_details': 'Detalles de la interfaz',
    'net_int_config_interface_edit': 'Editar interfaz',
    'net_int_config_interface_name': 'Nombre de la interfaz',
    'net_int_config_interface_offload': 'Descarga de interfaz',
    'net_int_config_interface_remove': 'Eliminar interfaz del bond',
    'net_int_config_interface_remove_message': '¿Está seguro de que desea eliminar esta interfaz enlazada?',
    'net_int_config_ip_add': 'Agregar IP',
    'net_int_config_mtu': 'MTU',
    'net_int_config_offload': 'Descargar',
    'net_int_config_onboot': 'Al iniciar',
    'net_int_config_speed': 'Velocidad',
    'net_int_config_vlan_add': 'Agregar VLAN',
    'no_access': 'Acceso denegado',
    'no_access_instructions': 'Copie y envíe lo siguiente a su administrador del sistema para solicitar acceso.',
    'no_access_message': 'Lo sentimos, no tienes permiso para ver esta página.',
    'no_access_message_access_path': 'está intentando acceder a la ruta:',
    'no_access_message_endpoint': 'El punto final de la API es:',
    'no_access_message_required_method': 'que requiere el método:',
    'no_access_message_user': 'El usuario:',
    'no_access_requirement': 'Requisito de acceso',
    'notification_clear_selected': 'Borrar notificación seleccionada',
    'notification_copy_debug_info': 'Copiar información de depuración',
    'notifications_clear': 'Borrar todas las notificaciones',
    'notifications_clear_error': 'Borrar errores',
    'notifications_clear_warning': 'Borrar advertencia',
    'notifications_delete_selected': 'Eliminar notificaciones seleccionadas',
    'notifications_see_all': 'Ver todas las notificaciones',
    'onboard_add_adc': 'Agregar un balanceador de carga',
    'onboard_add_adc_message': 'Ofrecemos soporte para balanceadores de carga de varios proveedores, elija uno a continuación.',
    'onboard_add_organization': 'Agregar su organización',
    'onboard_add_organization_message': 'Para usar el portal de Loadbalancer, deberá agregar algunos detalles de la organización.',
    'onboard_add_users': 'Agregar usuarios',
    'onboard_add_users_message': 'Puede invitar a varios usuarios para administrar y mantener sus balanceadores de carga.',
    'onboard_continue_to_portal': 'Continuar al portal',
    'onboard_current_user': 'El usuario actualmente conectado ya está asociado a una organización.',
    'onboard_do_it_later': 'Hazlo después',
    'onboard_edit_organization': 'Editar organización',
    'onboard_organization_private_key': 'Clave privada de la organización',
    'onboard_organization_private_key_message': 'Por favor, confirme su contraseña para descargar la clave privada de su organización.',
    'onboard_setup_issue_message': 'Si tiene problemas para incorporar esta organización, intente usar el botón de soporte en la esquina inferior derecha o confirme esto para cerrar sesión y volver a intentarlo.',
    'onboard_setup_issue_title': 'Problema al configurar esta organización',
    'onboard_user_already_assigned': 'Usuario ya asignado',
    'organization_change_denied': 'No tiene permisos para cambiar estos detalles.',
    'organization_send_continue': 'Enviar invitación y continuar',
    'organization_title': 'Organización',
    'physical_adv_conf': 'Configuración avanzada física',
    'physical_adv_conf_conn_trac_table_size': 'Tamaño de la tabla de seguimiento de conexiones',
    'physical_adv_conf_console': 'Consola',
    'physical_adv_conf_firewall_connections': 'Conexiones de firewall',
    'physical_adv_conf_http_proxy': 'Proxy HTTP',
    'physical_adv_conf_internet_access': 'Acceso a Internet',
    'physical_adv_conf_proxy_address': 'dirección del proxy',
    'physical_adv_conf_proxy_password': 'contraseña del proxy',
    'physical_adv_conf_proxy_port': 'puerto del proxy',
    'physical_adv_conf_proxy_username': 'nombre de usuario del proxy',
    'physical_adv_conf_smtp_address': 'dirección SMTP',
    'physical_adv_conf_smtp_password': 'contraseña SMTP',
    'physical_adv_conf_smtp_port': 'puerto SMTP',
    'physical_adv_conf_smtp_relay': 'Relé SMTP',
    'physical_adv_conf_smtp_server_address': 'dirección del servidor SMTP',
    'physical_adv_conf_smtp_username': 'nombre de usuario SMTP',
    'pipeline': 'Pipeline',
    'pipeline_add': 'Agregar pipeline',
    'pipelines': 'Pipelines',
    'platform_hyperV_description_long': 'Microsoft Hyper-V es una plataforma de virtualización basada en hipervisor desarrollada por Microsoft. Permite a los usuarios crear y administrar máquinas virtuales (VM) en un sistema basado en Windows. Hyper-V permite que múltiples sistemas operativos se ejecuten en una sola máquina física al virtualizar los recursos de hardware.',
    'platform_hyperV_description_short': 'Hyper-V te permite ejecutar múltiples sistemas operativos como máquinas virtuales en Windows.',
    'platform_kvm_description_long': 'El hipervisor KVM para máquinas virtuales basadas en el núcleo ofrece capacidades de virtualización completas. Proporciona a cada VM todos los servicios típicos del sistema físico, incluido el BIOS virtual y el hardware virtual, como procesador, memoria, almacenamiento y tarjetas de red. Como resultado, cada VM simula completamente una máquina física.',
    'platform_kvm_description_short': 'KVM proporciona a cada VM todos los servicios del sistema físico y hardware virtual.',
    'platform_nutanix_description_long': 'Este hipervisor empresarial de Nutanix está incluido con cada nodo Nutanix. Como hipervisor diseñado para HCI y la Nube Empresarial, AHV proporciona la opción de reducir los costos de licencia de software sin comprometer las características y funcionalidades.',
    'platform_nutanix_description_short': 'Nutanix AHV es un hipervisor empresarial incluido con cada nodo Nutanix.',
    'platform_virtualBox_description_long': 'Oracle VM VirtualBox es un software de virtualización de código abierto y multiplataforma que permite a los usuarios crear y administrar máquinas virtuales en sus sistemas host. Desarrollado por Oracle, VirtualBox admite una amplia gama de sistemas operativos invitados, lo que lo convierte en una herramienta versátil para el desarrollo, pruebas y ejecución de múltiples sistemas operativos en una sola máquina física.',
    'platform_virtualBox_description_short': 'VirtualBox es una versión de código abierto del hipervisor de VMWare.',
    'platform_vmWare_description_long': 'VMware ESXi es un hipervisor bare-metal y plataforma de virtualización desarrollada por VMware. Permite a los usuarios crear y administrar máquinas virtuales (VM) en un servidor sin necesidad de un sistema operativo anfitrión. ESXi es un hipervisor de Tipo 1, lo que significa que se ejecuta directamente en el hardware, proporcionando un control eficiente y directo sobre los recursos del sistema.',
    'platform_vmWare_description_short': 'VMware ESXi es un hipervisor bare-metal desarrollado por VMware para vSphere.',
    'platform_xen_description_long': 'Xen proporciona servicios que permiten que múltiples sistemas operativos informáticos se ejecuten en el mismo hardware de computadora de manera concurrente. El hipervisor del Proyecto Xen es un hipervisor de tipo 1 o bare-metal de código abierto, lo que permite que muchas instancias de un sistema operativo o diferentes sistemas operativos se ejecuten en paralelo en una sola máquina (o host).',
    'platform_xen_description_short': 'Xen es un hipervisor de tipo 1 gratuito y de código abierto.',
    'policies_privacy': 'Política de privacidad de Loadbalancer.org, Inc.',
    'policies_terms_of_service': 'Condiciones de servicio de Loadbalancer.org, Inc.',
    'portal_management': 'Gestión del portal',
    'portal_management_adoption_details': 'Detalles de adopción',
    'portal_management_adoption_status': 'Estado de adopción',
    'portal_management_adoption_submitted': 'Adopción enviada',
    'portal_management_connection_submitted': 'Detalles de conexión enviados',
    'portal_management_ip_address': 'Dirección IP de administración',
    'portal_management_login_email': 'Correo electrónico de inicio de sesión en el portal',
    'portal_management_login_password': 'Contraseña de inicio de sesión en el portal',
    'portal_management_not_submitted': 'No enviado',
    'portal_management_remove_adc': 'Eliminar ADC del Portal',
    'portal_management_remove_adc_message': '¿Está seguro de que desea eliminar este ADC del Portal?',
    'portal_management_shuttle_enabled': 'Habilitar lanzadera',
    'portal_management_shuttle_setup': 'Configuración de lanzadera y está listo para su adopción',
    'portal_management_subnets': 'Subredes de gestión',
    'prometheus_enable_exporter_ha_proxy': 'Exportador de capa 7 habilitado',
    'prometheus_enable_exporter_node': 'Exportador de nodos habilitado',
    'prometheus_error_duplicate': 'El puerto y la IP no pueden ser iguales que el otro exportador',
    'prometheus_exporter_port': 'Puerto del exportador',
    'prometheus_node_exporter': 'Exportador de nodos',
    'prometheus_set_exporters': 'Establecer exportadores',
    'pulse_conf_fail_over_limit': 'El límite debe estar entre 2000 y 10000',
    'pulse_conf_interval': 'El intervalo debe estar entre 1000 y 10000',
    'pulse_ha_auto_fail_back': 'Auto retorno de fallo',
    'pulse_ha_auto_fail_back_join': 'autoFailBack',
    'pulse_ha_change_ip': 'Para cambiar la dirección IP y el número de puerto en los que PulseHA está escuchando, primero deberá eliminar este nodo del clúster.',
    'pulse_ha_cluster_health': 'Estado de salud del clúster',
    'pulse_ha_cluster_status': 'Estado del clúster PulseHA',
    'pulse_ha_config': 'Configuración de PulseHA',
    'pulse_ha_current_settings': 'Configuración actual.',
    'pulse_ha_error': 'Hay un error con PulseHA',
    'pulse_ha_fail_over_interval': 'Intervalo de conmutación por error*',
    'pulse_ha_fail_over_limit': 'Límite de conmutación por error*',
    'pulse_ha_global_config': 'Configuración global de PulseHA',
    'pulse_ha_health_check_interval': 'Intervalo de verificación de salud*',
    'pulse_ha_node_cluster': 'Este nodo está en un clúster',
    'pulse_ha_port': 'Puerto PulseHA',
    'rbac_hint_update_yourself': 'No puedes actualizar tus propios permisos.',
    'rbac_hint_group_association_delete': 'No puedes eliminar un grupo con el que estás asociado.',
    'rbac_hint_group_association_update': 'No puedes editar un grupo con el que estás asociado.',
    'rbac_hint_role_association_delete': 'No puedes eliminar un rol con el que estás asociado.',
    'rbac_hint_role_association_update': 'No puedes editar un rol con el que estás asociado.',
    'rbac_group_add_role': 'Agregar grupo',
    'rbac_group_admin_access_text': 'Acceso de administrador',
    'rbac_group_assign_role': 'Asignar rol al grupo',
    'rbac_group_assign_role_select': 'Seleccionar rol',
    'rbac_group_assign_role_selected': 'Roles seleccionados',
    'rbac_group_delete_role': 'Eliminar grupo',
    'rbac_group_details': 'Detalles del grupo',
    'rbac_group_edit_role': 'Editar grupo',
    'rbac_group_management': 'Seleccionar usuarios',
    'rbac_group_management_selected': 'Usuario (s) seleccionado (s):',
    'rbac_group_name': 'Nombre del grupo',
    'rbac_group_ready_message': 'Por favor verifique sus datos. Puede editar sus datos o presionar el botón enviar a continuación cuando esté listo.',
    'rbac_groups_add_group': 'Agregar grupo',
    'rbac_groups_cancel_text': 'Volver a Grupos',
    'rbac_groups_delete_group': 'Eliminar grupo',
    'rbac_groups_edit_group': 'Editar grupo',
    'rbac_groups_no_roles': 'No tienes ningún grupo o rol configurado',
    'rbac_groups_selected_groups': 'Grupos seleccionados',
    'rbac_role_details': 'Detalles del rol',
    'rbac_role_duplicate': 'Rol duplicado',
    'rbac_role_duplicated_from': 'Duplicado de',
    'rbac_role_management': 'Gestión de roles',
    'rbac_role_name': 'Nombre de rol',
    'rbac_role_ready_message': 'Por favor comprueba tus detalles. Puede editar sus datos o presionar el botón enviar a continuación cuando esté listo.',
    'rbac_roles_add_role': 'Agregar rol',
    'rbac_roles_admin_access_text': 'Acceso de administrador',
    'rbac_roles_cancel_text': 'Volver a Roles',
    'rbac_roles_delete_role': 'Eliminar rol',
    'rbac_roles_edit_collapse_all': 'Desplegar todo',
    'rbac_roles_edit_expand_all': 'Expandir todo',
    'rbac_roles_edit_role': 'Editar rol',
    'rbac_users_add_user': 'Agregar usuario',
    'rbac_users_delete_selected': 'Eliminar usuarios seleccionados',
    'rbac_users_details': 'Detalles del usuario',
    'rbac_users_disable_user': 'deshabilitar usuario',
    'rbac_users_edit_user': 'Editar usuario',
    'rbac_users_edit_user_permissions': 'Editar permisos de usuario',
    'rbac_users_invite_user': 'Invitar usuario',
    'rbac_users_ready': 'Listo para añadir usuario',
    'rbac_users_return_to_users': 'Volver a Usuarios',
    'rbac_users_roles_groups_message': 'Debes añadir al menos un rol o un grupo para poder continuar.',
    'rbac_users_submit_user': 'Enviar usuario',
    'rbac_users_submit_user_warning': 'Estás editando la contraseña del usuario actual. Al enviarla, deberás iniciar sesión nuevamente con tu nueva contraseña. ¿Deseas continuar?',
    'rbac_users_update_message': 'Un usuario puede editar sus datos personales en la configuración de la cuenta.',
    'rbac_users_update_permissions': 'Actualizar permisos',
    'rbac_widget_no_permissions': 'No tienes permiso para ver este widget',
    'region_add': 'Agregar región',
    'region_add_new': 'Agregar nueva región',
    'region_delete': 'Eliminar región',
    'region_delete_multiple_regions': 'Eliminar varias regiónes',
    'region_delete_selected_subnets': 'Eliminar subredes seleccionadas',
    'region_deleting_regions': 'Eliminar regiones',
    'region_edit': 'Editar región',
    'region_no_subnets_hint': 'No hay subredes para ver',
    'region_view_subnets': 'Ver subred(es)',
    'registration_already_have_account': '¿Ya tienes una cuenta?',
    'registration_error': 'Error de registro',
    'registration_policy_message': 'Al hacer clic en Crear cuenta, aceptas nuestro',
    'registration_sign_up_message': 'Regístrese para obtener una experiencia gratuita de Loadbalancer hoy',
    'registration_success_msg': '¡Éxito! Te hemos enviado un correo electrónico de activación para que verifiques y completes tu registro.',
    'registration_title': 'Regístrate en el Portal.',
    'relogin-sso-click': 'Haz clic para iniciar sesión nuevamente con SSO.',
    'relogin_cert_expired_text': 'Su certificado ha caducado. Por favor, cierre sesión',
    'relogin_requesting_auth_token': 'Solicitando token de AUT',
    'reports_distribution_state': 'Estado de distribución',
    'resources_no_images_available': 'Actualmente no hay imágenes para la plataforma seleccionada',
    'restart_page_sub_title': 'Esto puede llevar algunos minutos, por favor espere y será redirigido a la página de inicio de sesión una vez completado.',
    'restart_page_title': 'Reiniciando el sistema',
    'routing_add_route': 'Agregar ruta',
    'routing_default_gateway': 'Puerta de enlace predeterminada',
    'routing_delete_route': 'Eliminar ruta',
    'routing_static_routes': 'Rutas estáticas',
    'routing_via_interface': 'A través de la interfaz',
    'saml_download_xml': 'Descargar XML',
    'saml_modal_message': 'Por favor, introduzca su dirección de correo electrónico de la organización',
    'saml_modal_title': 'Inicio de sesión SAML',
    'saml_remove_message': '¿Está seguro de que desea eliminar la configuración SAML de su organización?',
    'saml_remove_title': 'Eliminar configuración SAML',
    'saml_setup_form_label': 'Pegue aquí su enlace de metadatos:',
    'saml_setup_form_enforce': 'Imponer SAML para todos los usuarios',
    'saml_setup_message': 'Si no está seguro de cómo configurar el acceso SAML, por favor contacte a nuestro equipo de soporte.',
    'saml_setup_need_help': '¿Necesitas ayuda?',
    'saml_title': 'SAML',
    'saml_title_entityId': 'ID de entidad / URL de audiencia',
    'saml_title_issuer': 'ID del emisor',
    'saml_title_message': 'SAML permite el inicio de sesión a través de su proveedor de identidad SAML con funcionalidad de inicio de sesión único.',
    'saml_title_message_help': 'Para obtener ayuda sobre cómo configurar SAML',
    'saml_title_message_help_link': 'contacte a nuestro equipo de soporte',
    'saml_title_name_id': 'Formato de ID de nombre',
    'saml_title_sso_url': 'URL de inicio de sesión único',
    'saml_title_what_is': '¿Qué es SAML?',
    'saml_title_xml_message': 'Si su proveedor de identidad SAML admite la configuración automática, puede descargar la configuración en XML a continuación.',
    'saml_upgrade_message': 'Mejore la seguridad de su organización utilizando SAML para el acceso a su portal. ¡Es bueno!',
    'saml_upgrade_title': 'Actualice para usar SAML',
    'schedule_add': 'Agregar horario',
    'schedule_clear_filters': 'Borrar filtros',
    'schedule_create': 'Crear horario',
    'schedule_delete': 'Eliminar horario',
    'schedule_delete_message': '¿Está seguro de que desea eliminar este horario?',
    'schedule_edit': 'Editar horario',
    'schedule_type': 'Tipo de horario',
    'schedule_update': 'Actualizar horario',
    'scheduled_date_time': 'Fecha/Hora programada',
    'scheduled_date_time_utc': 'Hora universal coordinada',
    'scheduled_type': 'Tipo programado',
    'scheduled_update': 'Actualización programada',
    'scheduler': 'Programador',
    'scheduler_error_message_no_adc': 'No existe un ADC con este ID',
    'scheduler_local_time': 'Hora local',
    'scheduler_save_schedule': 'Guardar horario',
    'schedules_empty_message': 'Establezca un horario conveniente para actualizar y realizar copias de seguridad de sus electrodomésticos, con 1 año de historial.',
    'schedules_empty_title': 'Aún no se han agregado horarios.',
    'schedules_upgrade_message': 'Los horarios le permiten realizar copias de seguridad y actualizar sus ADC en cualquier momento y de forma recurrente.',
    'schedules_upgrade_title': 'Actualice a la programación de activos.',
    'search_no_results': 'No se encontraron resultados para',
    'security': 'Seguridad',
    'security_affected_version': 'Versión(es) afectada(s)',
    'security_certs_upgrade_message': ' Mejore la seguridad de su organización utilizando certificados para su portal.',
    'security_certs_upgrade_title': 'Actualice para crear certificados.',
    'security_cve_details': 'Detalles de CVE',
    'security_dashboard': 'Tablero',
    'security_how_to_fix': 'Cómo solucionarlo',
    'security_insights': 'Información',
    'security_insights_label': 'Información de seguridad',
    'security_insights_upgrade_message': 'Mejore la seguridad de su organización utilizando Insights para su portal. ¡Es bueno!',
    'security_insights_upgrade_title': 'Actualice para usar Insights',
    'security_more_details': 'Más detalles',
    'security_need_help': '¿Necesita ayuda?',
    'security_nist_details': 'Detalles de NIST',
    'security_operational_risk': 'Riesgo operativo',
    'security_our_recommendation': 'Nuestra recomendación',
    'security_published': 'Publicado',
    'security_published_last': 'Última modificación',
    'security_publisher': 'Editor',
    'security_risk': 'Riesgo de seguridad',
    'security_severity_score': 'Puntuación de gravedad',
    'security_update_adc': 'Actualizar ADC',
    'security_vulnerability_id': 'ID de vulnerabilidad',
    'security_update_adc_message': 'Actualización aún no admitida para este proveedor',
    'security_vulnerability_info': 'Información de vulnerabilidad',
    'service_details': 'Detalles del servicio',
    'service_details_add_backend': 'Agregar backend',
    'service_details_add_backend_disabled': 'La capa 4 actualmente no admite varios backends',
    'service_details_edit_backend': 'Editar backend',
    'service_details_error_type': 'No hay tipos de servicios coincidentes',
    'services_abort_on_close': 'Abortar al cerrar',
    'services_accept_invalid_http_requests': 'Aceptar solicitudes HTTP no válidas',
    'services_accept_invalid_http_response': 'Aceptar respuestas HTTP no válidas',
    'services_add_backend_service': 'Agregar servicio de backend',
    'services_add_real_server': 'Agregar servidor real',
    'services_agent_port': 'Puerto de agente',
    'services_application_cookie_name': 'Nombre de la cookie de la aplicación',
    'services_apply_all': 'Aplicar todo',
    'services_backend_connections': 'Conexiones de backend',
    'services_backend_mode_disabled_message': 'El modo de backend está desactivado ya que el(s) frontend(s) vinculado(s) es HTTP.',
    'services_backend_source_address': 'Dirección de origen del backend',
    'services_balance_mode': 'Modo de balanceo',
    'services_check_port': 'Puerto de comprobación',
    'services_clear_stick_table_on_drain': 'Borrar tabla de sesiones en drenaje',
    'services_client_connection_timeout': 'Tiempo de espera de conexión del cliente',
    'services_compression': 'Compresión',
    'services_backend_configuration': 'Configuración de backend',
    'services_conn_distribution_method': 'Método de distribución de conexión',
    'services_connection_redispatch': 'Redistribución de conexión',
    'services_count': 'conteo',
    'services_delete': 'Eliminar servicio',
    'services_disabled_on_start': 'Desactivado al iniciar',
    'services_drain': 'Drenar servicio',
    'services_duplicate_backend_service': 'Duplicar servicio de backend',
    'services_duplicate_frontend': 'Duplicar frontend',
    'services_duplicate_real_server': 'Duplicar servidor real',
    'services_edit_backend_service': 'Editar servicio de backend',
    'services_edit_frontend': 'Editar frontend',
    'services_edit_real_server': 'Editar servidor real',
    'services_enable_client_conn_timeout': 'Activar tiempo de espera de conexión del cliente',
    'services_enable_duplicates': 'Activar duplicados',
    'services_enable_gzip_compression': 'Activar compresión gzip',
    'services_enable_hsts': 'Activar HSTS',
    'services_enable_server_conn_timeout': 'Activar tiempo de espera de conexión del servidor',
    'services_enable_ssl_termination': 'Activar terminación SSL',
    'services_enable_tproxy': 'Activar TProxy',
    'services_enable_x_forwarded': 'Habilitar encabezado X-forwarded-for',
    'services_enable_zero_round_trips': 'Habilitar viajes de ida y vuelta cero',
    'services_encrypt_to_real_server': 'Encriptar al servidor real',
    'services_ensure_requests_untouched': 'Asegurar que todas las solicitudes de 0-RTT no se modifiquen (la solicitud se puede realizar varias veces sin obtener un resultado diferente) antes de habilitar esta función',
    'services_external_check_script': 'Script de verificación externa',
    'services_feedback_agent_interval': 'Intervalo del agente de retroalimentación',
    'services_force_to_https': 'Forzar a HTTPS',
    'services_frontend_configuration': 'Configuración del frontend',
    'services_frontend_floating_ip': 'Esta es la dirección IP flotante del frontend y la máscara de IP flotante.',
    'services_frontend_floating_port': 'Estos son los puertos de IP flotante del frontend.',
    'services_frontend_mode_disabled_message': 'El modo de frontend está desactivado ya que el(s) backend(s) vinculado(s) es TCP.',
    'services_greater_than': 'Mayor que',
    'services_greater_than_equals': 'Mayor o igual que',
    'services_halt': 'Detener servicio',
    'services_health_check_type': 'Tipo de comprobación de salud',
    'services_host_header': 'Encabezado de host',
    'services_hsts_timeout': 'Tiempo de espera de HSTS',
    'services_http_cookie_max_idle': 'Máximo tiempo inactivo de la cookie HTTP',
    'services_http_cookie_max_life': 'Vida máxima de la cookie HTTP',
    'services_http_cookie_name': 'Nombre de la cookie HTTP',
    'services_http_idle_connection_reuse': 'Reutilización de conexión inactiva HTTP',
    'services_http_pipeline_mode': 'Modo de canalización HTTP',
    'services_http_pretend_keepalive': 'Pretender mantener la conexión HTTP',
    'services_http_request_timeout': 'Tiempo de espera de solicitud HTTP (protección contra DDoS)',
    'services_https_redirect_code': 'Código de redirección HTTPS',
    'services_individual_ports': 'Puerto(s) individual(es)',
    'services_layer_4_mode': 'Modo de capa 4',
    'services_layer_7_mode': 'Modo de capa 7',
    'services_less_than': 'Menor que',
    'services_less_than_equals': 'Menor o igual que',
    'services_min_real_servers': 'Mínimo de servidores reales',
    'services_minimum_conns': 'Conexiones mínimas',
    'services_mode': 'Modo de servicio',
    'services_monitor_configuration': 'Configuración de monitorización',
    'services_monitor_uri': 'URI de monitorización',
    'services_name': 'Nombre del servicio',
    'services_no_backends': 'No se encontraron backends',
    'services_notification_changes': 'Se ha cambiado la configuración de los siguientes servicios:',
    'services_notification_commit_message': 'Haga clic aquí para visitar la página de servicios y confirmar sus cambios.',
    'services_number_of_servers': 'Número de servidores reales',
    'services_number_real_servers_message': 'El número de servidores reales que desea crear.',
    'services_online': 'Servicio en línea',
    'services_port_ranges': 'Rango(s) de puerto',
    'services_ports_placeholder': 'Puerto(s)',
    'services_proxy_protocol': 'Protocolo de proxy',
    'services_re_encrypt_to_backend': 'Reencriptar al backend',
    'services_real_server': 'Servidor real',
    'services_real_server_add': 'Agregar servidor real',
    'services_real_server_configuration': 'Configuración real del servidor',
    'services_real_server_confirm_message': '¿Está seguro de que desea perder los cambios en el formulario?',
    'services_real_server_confirm_title': 'Confirmar perder cambios',
    'services_real_server_ip': 'Dirección IP',
    'services_real_server_name': 'Etiqueta del servidor real',
    'services_real_server_port': 'Puerto del servidor real',
    'services_real_server_select': 'Seleccione el servidor real existente',
    'services_real_server_usage': 'Uso real del servidor',
    'services_real_servers': 'Servidores reales',
    'services_request_to_send': 'Solicitud para enviar',
    'services_response_expected': 'Respuesta esperada',
    'services_restart': 'Servicios del sistema',
    'services_return_to_service_details': 'Volver a los detalles del servicio',
    'services_search_backend': 'Buscar dentro de este backend',
    'services_send_proxy_protocol': 'Enviar protocolo de proxy',
    'services_server_timeout': 'Tiempo de espera del servidor',
    'services_slow_start_time': 'Tiempo de inicio lento',
    'services_table_size': 'Tamaño de la tabla',
    'services_tcp_keep_alive': 'Mantener viva la conexión TCP',
    'services_tcp_keepalive': 'Mantener viva la conexión TCP',
    'services_timeout': 'Tiempo de espera',
    'services_tunnel_timeout': 'Tiempo de espera del túnel',
    'services_xff_ip_position': 'Posición de IP de XFF',
    'shutdown_completed_page_title': 'Apagado completado',
    'shutdown_completed_sub_title': 'El apagado del sistema se ha completado con éxito.',
    'shutdown_page_sub_title': 'Su sistema se está apagando.',
    'shutdown_page_title': 'Apagado del sistema',
    'shuttle_install_complete': 'Conexión exitosa',
    'shuttle_install_message_credentials': 'Por favor, visite la página de gestión del portal en su dispositivo y complete el formulario de adopción.',
    'shuttle_install_message_token': 'Por favor, visite su dispositivo que está configurando como un shuttle y ejecute el comando copiado anteriormente.',
    'shuttle_install_wait': 'Esperando adopción...',
    'shuttle_no_vendor_message': 'El proveedor seleccionado no coincide con nuestra lista de proveedores compatibles',
    'shuttle_no_vendor_title': 'No se encontró ningún proveedor',
    'snmp_conf_delete_user_message': '¿Está seguro de que desea eliminar a este usuario de su configuración?',
    'snmp_conf_protocol_in_use': 'Usando el protocolo:',
    'snmp_conf_select_version': 'Seleccionar versión del protocolo',
    'snmp_conf_settings_add': 'Agregar configuración SNMP',
    'snmp_conf_settings_edit': 'Editar configuraciones de SNMP',
    'snmp_conf_snmp_auth_passphrase': 'Frase de autorización SNMP',
    'snmp_conf_snmp_community': 'Comunidad SNMP',
    'snmp_conf_snmp_contact': 'Contacto SNMP',
    'snmp_conf_snmp_enable_v2': 'V2',
    'snmp_conf_snmp_enable_v3': 'V3',
    'snmp_conf_snmp_location': 'Ubicación SNMP',
    'snmp_conf_snmp_privacy_alg': 'Algoritmo de privacidad',
    'snmp_conf_snmp_privacy_passphrase': 'Frase de privacidad SNMP',
    'snmp_conf_snmp_protocol_version': 'Versión del protocolo SNMP',
    'socket_service_reconnect_message': 'Intentando reconectar al websocket',
    'ssl_certificates': 'Certificados SSL',
    'ssl_certificates_usage': 'Uso de certificados SSL',
    'ssl_cipher_lists': 'Listas de cifrado SSL',
    'ssl_offload_allowed_hostnames': 'Nombres de host permitidos',
    'ssl_offload_cipher_list': 'Lista de cifrado',
    'ssl_offload_delete_certificate': 'Eliminar certificado',
    'ssl_offload_delete_termination_title': 'Eliminar asociación de certificado SSL',
    'ssl_offload_denied_hostnames': 'Nombres de host denegados',
    'ssl_offload_hostnames_add_allowed': 'Agregar permitidos',
    'ssl_offload_hostnames_add_denied': 'Agregar denegados',
    'ssl_offload_hostnames_allowed': 'Nombres de host permitidos',
    'ssl_offload_hostnames_denied': 'Nombres de host denegados',
    'ssl_offload_hostnames_placeholder': 'Nombre(s) de host',
    'ssl_offload_manage_certificate': 'Gestionar certificado',
    'ssl_offload_manage_cipher_list': 'Gestionar lista de cifrado',
    'ssl_offload_remove_ssl_cert_association': 'Eliminar asociación de certificado SSL',
    'ssl_offload_remove_ssl_cert_association_message': 'Al eliminar esta asociación de certificado SSL, desactivará la terminación SSL. ¿Está seguro de que desea eliminar esta asociación de certificado SSL?',
    'static_ip': 'IP estática',
    'static_ip_add': 'Agregar IP estática',
    'static_ip_change': 'IP cambiada',
    'static_ip_change_message': 'La IP que está cambiando está asignada a un servicio y ese servicio deberá recargarse',
    'static_ip_delete_multiple_ips': 'Eliminar múltiples IPs',
    'static_ip_delete_selected': 'Eliminar IPs estáticas seleccionadas',
    'static_ip_edit': 'Editar IP estática',
    'static_ip_no_usage': 'no hay datos de uso disponibles',
    'static_ip_not_in_use': 'No en uso',
    'static_ip_usage': 'Uso de IP estática',
    'static_ip_usage_for_ip': 'Uso para IP',
    'static_ip_used_in': 'Usado en',
    'static_route': 'Ruta',
    'static_route_add': 'Agregar ruta',
    'static_route_default_gw_change': 'Cambiar la dirección de la puerta de enlace de la ruta predeterminada',
    'static_route_default_gw_change_message': 'Estás a punto de cambiar la puerta de enlace de la ruta predeterminada. ¿Estás seguro de que deseas hacer esto?',
    'static_route_delete': 'Eliminar ruta estática',
    'static_route_delete_multiple_routes': 'Eliminar múltiples rutas',
    'static_route_delete_selected': 'Eliminar rutas seleccionadas',
    'static_route_edit': 'Editar ruta',
    'static_route_gateway': 'Pasarela',
    'static_route_group': 'Grupo',
    'static_route_range': 'rango de IP',
    'static_route_type': 'Tipo',
    'static_routes': 'Rutas',
    'storage_download_latest': 'Descargar el último',
    'storage_download_restriction_notification': 'Actualmente no tienes una clave de organización, necesitas solicitar una a tu administrador.',
    'storage_empty_message': 'Cuando cree una copia de seguridad de su ADC u otros servicios, aparecerá aquí.',
    'storage_empty_title': 'Aún no se han añadido copias de seguridad.',
    'storage_modal_id_message': 'Se requiere el ID del dispositivo ADC como contraseña para el archivo encriptado, no podrá utilizar la copia de seguridad sin este ID:',
    'storage_modal_id_title': 'Contraseña del archivo de copia de seguridad',
    'subscriptions_adc_connections': 'Conexiones ADC',
    'subscriptions_add_more_connections': 'Agregue 10 conexiones ADC adicionales a su Portal por solo',
    'subscriptions_annual_plan': 'Plan anual',
    'subscriptions_backup_history': 'Con 1 año de historia',
    'subscriptions_billed_at': 'Facturado en',
    'subscriptions_book_a_demo': 'Reservar una demostración',
    'subscriptions_business': 'Portal de negocios',
    'subscriptions_business_subtitle': 'Para varios equipos',
    'subscriptions_current_plan': 'Plan actual',
    'subscriptions_enterprise_demo_message': '¡Listo para empresas! Póngase en contacto con nuestro equipo para obtener un presupuesto personalizado.',
    'subscriptions_for_starter_projects': 'Para proyectos de inicio',
    'subscriptions_free': 'Gratis',
    'subscriptions_monthly_plan': 'Planes mensuales',
    'subscriptions_need_more_connections': '¿Necesitas más conexiones?',
    'subscriptions_per_adc': 'por ADC',
    'subscriptions_pro': 'Portal pro',
    'subscriptions_pro_subtitle': 'Para profesionales',
    'subscriptions_support_level': 'Nivel de soporte',
    'subscriptions_support_message': 'Plataforma del portal (en su zona horaria)',
    'subscriptions_support_type': 'Cuenta y facturación',
    'subscriptions_tailored': 'Portal a medida',
    'subscriptions_tailored_subscription_message': 'Nuestra suscripción personalizada está diseñada para funcionar con grandes empresas. Reserve una demostración gratuita con nosotros hoy.',
    'subscriptions_tailored_subtitle': 'Para una personalización total',
    'support': 'Soporte',
    'support_close_ticket': 'Cerrar ticket',
    'support_close_ticket_message': '¿Está seguro de que desea cerrar este ticket? Ya no se mostrará en los tickets de su organización.',
    'support_create_ticket': 'Crear Ticket',
    'support_delete_ticket': 'Eliminar ticket',
    'support_get': 'Obtener soporte',
    'support_send_feedback': 'Enviar comentarios',
    'support_technical_archive_success': 'Archivo de soporte descargado',
    'support_technical_contact_us': 'Contáctenos',
    'support_technical_create_support_archive': 'Creando archivo de soporte. Por favor, espere...',
    'support_technical_create_support_archive_error': 'Se encontró un error durante la creación del archivo de soporte.',
    'support_technical_download_info': 'Esta página genera un archivo con todos los archivos necesarios, que luego se descarga en su PC.',
    'support_technical_info': 'Cuando se ponga en contacto con el soporte de Loadbalancer.org, es posible que se le pida que proporcione la configuración del balanceador de carga y los archivos de registro.',
    'support_technical_recommended': 'Ya hemos seleccionado la opción de descarga recomendada para usted.',
    'support_technical_support_download': 'Descarga de soporte técnico',
    'support_telephone': 'Soporte telefónico',
    'support_tickets_empty_message': 'Actualmente no tienes ningún ticket de soporte para mostrar.',
    'support_tickets_empty_title': 'Sin tickets de soporte',
    'system_control_confirm_restart': '¿Está seguro de que desea reiniciar el balanceador de carga?',
    'system_control_confirm_shutdown': '¿Está seguro de que desea apagar el balanceador de carga?',
    'system_control_confirm_unlock': '¿Está seguro de que desea desbloquear su balanceador de carga?<br>Si está bloqueado por un motivo genuino, ¡podría dañar su dispositivo!',
    'system_control_logout_info': 'Se cerrará la sesión del cliente',
    'system_control_reboot_load_balancer_message': 'Su balanceador de carga se está reiniciando y volverá a estar en línea en breve',
    'system_control_restart_lb': 'Reiniciar balanceador de carga',
    'system_control_shutdown_lb': 'Apagar balanceador de carga',
    'system_control_unlock': 'Desbloquear',
    'system_control_view_error_log': 'Ver registro de errores',
    'system_control_error_log': 'Registro de errores',
    'system_overview': 'Resumen del sistema',
    'system_overview_details': 'Detalles del sistema',
    'system_update_change_log': 'Registro de cambios',
    'system_update_confirm_unlock': '¿Está seguro de que desea desbloquear su balanceador de carga?<br>Si está bloqueado por un motivo genuino, ¡podría dañar su dispositivo!',
    'system_update_confirm_update_message': '¿Está seguro de que desea actualizar el balanceador de carga?',
    'system_update_current_version': 'Versión actual',
    'system_update_failed': 'No se pudo conectar al repositorio. Solo actualizaciones manuales.',
    'system_update_manual_update': 'Actualización manual',
    'system_update_online_update': 'Actualización en línea',
    'system_update_os_update': 'Actualización del sistema operativo',
    'system_update_os_version': 'Versión del sistema operativo',
    'system_update_package_to_update': 'Paquetes para actualizar: ',
    'system_update_package_to_update_major': 'Versión importante para actualizar: ',
    'system_update_package_update_failed': 'Error en la actualización del paquete',
    'system_update_package_updating': 'Actualizando paquetes',
    'system_update_package_wait': 'Por favor espere.....',
    'system_update_pending_version': 'Versión pendiente',
    'system_update_release': 'Versión',
    'system_update_restart': 'Su balanceador de carga requiere un reinicio',
    'system_update_restart_required': 'Uno o más paquetes requieren que su balanceador de carga se reinicie. Al hacer clic en reiniciar, se cerrará la sesión. Su balanceador de carga puede no estar disponible durante unos minutos',
    'system_update_software_update': 'Actualización de software',
    'system_update_system_packages_up_to_date': 'Todos los paquetes están actualizados',
    'system_update_system_up_to_date': 'Todo está actualizado',
    'system_update_update_archive': 'Por favor, seleccione el archivo de actualización',
    'system_update_version': 'Número de versión',
    'system_updates': 'Actualizaciones del sistema',
    'tab_no_access': 'No tienes acceso para ver esta pestaña',
    'table_close_overlay': 'Cerrar superposición de tabla',
    'table_component_all': 'Todos ',
    'table_component_all_selected_page': ' filas en esta página están seleccionadas.',
    'table_component_are_selected': ' están seleccionadas.',
    'table_component_clear_selection': 'Limpiar selección.',
    'table_go_to_page': 'Ir a la página',
    'table_hidden_columns': 'Columnas ocultas',
    'table_landscape_on_small_devices': 'horizontal en dispositivos pequeños',
    'table_no_data': 'No hay datos para mostrar',
    'table_show_records': 'Mostrar registros',
    'tables_are_best_viewed': 'Las tablas se ven mejor en',
    'tags': 'Etiquetas',
    'tags_duplicate_message': 'Esta etiqueta ya existe (puede estar en minúsculas)',
    'tags_max-length_message': 'Esta etiqueta es demasiado larga, máximo de caracteres',
    'tags_max_message': 'Ha alcanzado el número máximo de etiquetas permitidas',
    'tags_min-length_message': 'Esta etiqueta es demasiado corta',
    'tags_place_holder': 'Agregar una etiqueta y presionar enter',
    'template_selector_import_template': 'Importar una plantilla',
    'template_selector_load_saved_template': 'Cargar plantilla guardada',
    'template_selector_remove_template': 'Eliminar plantilla',
    'template_selector_select_service_type': 'Por favor, seleccione una plantilla para configurar',
    'ticket': 'Ticket',
    'ticket_type': 'Tipo de ticket',
    'ticket_update': 'Actualizar ticket',
    'tickets_all': 'Todos los tickets',
    'update_settings': 'Actualizar configuración',
    'upload_change_file': 'Cambiar archivo',
    'upload_choose_file': 'Elegir archivo',
    'upload_pem_pfx': 'Cargar (PEM / PFX)',
    'upload_update_pem': 'Actualizar PEM',
    'upload_update_pem_pfx': 'Actualizar (PEM / PFX)',
    'upload_update_pfx': 'Actualizar PFX',
    'usage_no_usage': 'no hay datos de uso disponibles',
    'usage_not_in_use': 'No en uso',
    'usage_used_in': 'Usado en',
    'user_activation_passcode_invite_message': 'Su invitado necesitará un código de acceso de un solo uso para activar su cuenta. Por favor, tome nota de esto y envíelo a ellos.',
    'user_add_new_user_message': 'Por favor, ingrese su contraseña para enviar la invitación',
    'user_copy_passcode': 'Copiar código de acceso',
    'user_delete_group': 'Eliminar grupo',
    'user_delete_group_message': '¿Estás seguro de que deseas eliminar este grupo?',
    'user_delete_message_endurance': '¿Está seguro de que desea eliminar este usuario de este dispositivo?',
    'user_delete_message_portal': '¿Está seguro de que desea eliminar a este usuario?',
    'user_delete_users_message_portal': '¿Está seguro de que desea eliminar los usuarios seleccionados?',
    'user_delete_portal': 'Eliminar asociación de usuario',
    'user_delete_role': 'Eliminar rol',
    'user_delete_role_message': '¿Está seguro de que desea eliminar este rol?',
    'user_hint_delete': 'No puedes eliminar al único propietario',
    'user_hint_delete_yourself': 'No puedes borrarte a ti mismo',
    'user_hint_edit': 'No puedes editar el único propietario',
    'user_interface': 'Interfaz de usuario',
    'user_interface_api_port': 'Puerto de API',
    'user_interface_confirm': 'Confirmar interfaz de usuario',
    'user_interface_reload_model_text': 'Httpd y PulseHA se están recargando. Se cerrará la sesión y se recargará en',
    'user_interface_set_interface': 'Establecer interfaz de usuario',
    'user_interface_ssh_enabled': 'SSH habilitado',
    'user_interface_ssh_port': 'Puerto SSH',
    'user_management': 'Gestión de usuarios',
    'user_please_confirm_copy_passcode': 'Por favor, confirme que ha copiado el código de acceso',
    'user_send_invite': 'Enviar invitación',
    'users_add_user': 'Agregar usuario',
    'users_edit_user': 'Editar usuario',
    'users_list_last_login_in': 'Último inicio de sesión',
    'users_list_last_otp_enabled': 'OTP habilitado',
    'view_config': 'Ver configuración',
    'view_config_certs': 'Certificados',
    'view_config_ciphers': 'Cifrados',
    'view_config_data_services': 'Servicios de datos',
    'view_config_fallback_server': 'Páginas de respaldo',
    'view_config_fip': 'FIPs',
    'view_config_gslb': 'GSLB',
    'view_config_haproxy': 'HAProxy',
    'view_config_healthchecks': 'Comprobaciones de salud',
    'view_config_ip_groups': 'Grupos IP',
    'view_config_ipvsdirector': 'Director de servicios virtuales IP',
    'view_config_lbconfig': 'Archivo de configuración JSON',
    'view_config_lbconfig_message': 'No se puede obtener el archivo de configuración JSON',
    'view_config_message': 'No se puede obtener el archivo de configuración',
    'view_config_nic': 'Configuración de red',
    'view_config_pulseha': 'PulseHA',
    'view_config_pulseha_message': 'No se puede obtener el archivo de configuración de Pulse HA',
    'view_config_rbac': 'RBAC',
    'view_config_routing_table': 'Tabla de enrutamiento',
    'view_config_routing_table_message': 'No se puede obtener el archivo de configuración de la tabla de enrutamiento',
    'view_config_service_ips': 'IPs de servicio',
    'view_config_sidecar': 'Sidecar',
    'view_config_sips': 'SIPs',
    'view_config_snmp': 'Configuración SNMP',
    'view_config_system': 'Sistema',
    'view_config_unknown': 'Configuración desconocida',
    'virtual_service_widget_frontend_overview': 'Resumen del frontend',
    'widget_collecting_data': 'Recopilando datos',
    'widget_everything_good': 'Todo parece estar bien',
    'widget_ha_proxy_message': 'Necesita reiniciar Ha Proxy ya que TODOS sus servicios están en estado pendiente',
    'widget_no_data_collected': 'Sin datos',
    'widget_no_permission': 'No tienes permiso para ver este widget',
    'widget_no_data_error': 'No se puede obtener los datos del widget.',
    'widget_upgrade_options': 'Opciones de actualización',
    'wizard_change_template': 'Cambiar plantilla',
    'wizard_change_template_text': 'Cambiar la plantilla eliminará todos los datos del formulario actual. ¿Desea continuar?',
    'wizard_leaving_partner_mode': 'Abandonando el modo de socio',
    'wizard_leaving_partner_mode_text': 'Está a punto de abandonar el modo de socio. No podrá volver al modo de socio después de hacer clic en confirmar. ¿Desea continuar?',
    'wizard_loading': 'Cargando Asistente...',
    'wizard_save_template': 'Guardar plantilla',
    'wizard_skip_step': 'Salta este paso',
    'wizard_step_errors': 'Errores de paso',
    'wizard_submit_button_message': 'Este botón de enviar omite todos los pasos posteriores; los cambios que haya realizado en este paso podrían afectar otros pasos.',
    'wizard_user_template': 'Seleccione una plantilla de su máquina local',

// General labels/phrases
    'activate_account': 'Activar cuenta',
    'adc_access': 'Acceso al ADC',
    'add_another': 'Agregar otro',
    'add_cert': 'Agregar certificado',
    'add_cert_upper': 'Agregar Certificado',
    'add_service': 'Agregar servicio',
    'already_exists': ' ya existe.',
    'already_in_use': ' ya está en uso.',
    'at_least_one_required': 'Se requiere al menos uno.',
    'backups_used': 'Backups utilizados',
    'cant_be_deleted': 'no se pueden eliminar porque están en uso.',
    'certificate_expired': 'Certificado caducado.',
    'cidr_missing': 'Por favor, utiliza la notación CIDR para la subred. Ejemplo: 127.0.0.1/24',
    'client_connections': 'Conexiones de cliente',
    'confirm_email': 'Confirmar correo electrónico',
    'confirm_delete': 'Confirmar eliminación',
    'confirm_delete_message': '¿Estás seguro de que deseas eliminar ',
    'connection_details': 'Detalles de la conexión',
    'connection_method': 'Método de conexión',
    'connection_options': 'Opciones de conexión',
    'contact_number': 'Número de contacto',
    'contact_sales': 'Contactar ventas',
    'contact_us': 'Contáctenos',
    'copy_output': 'Copiar salida',
    'create_account': 'Crear cuenta',
    'created_by': 'Creado por',
    'database_name': 'Nombre de la base de datos',
    'date_just_now': 'Ahora mismo',
    'date_time': 'Fecha y hora',
    'date_time_sys_title': 'Fecha y hora del sistema',
    'delete_backup': 'Eliminar copia de seguridad',
    'delete_backup_message': '¿Estás seguro de que quieres eliminar esta copia de seguridad?',
    'delete_group': 'Eliminar grupo',
    'delete_ip': 'Eliminar IP',
    'delete_ips': 'Eliminar IPs',
    'delete_user': 'Eliminar usuario',
    'delete_users': 'Eliminar usuarios',
    'domain_name': 'Nombre de dominio',
    'down_time': 'Tiempo de inactividad',
    'download_csv': 'Descargar CSV',
    'downloading': 'Descargando',
    'external_weight': 'Peso dinámico externo',
    'feedback_agent': 'Agente de retroalimentación',
    'feedback_agent_port': 'Puerto del agente de retroalimentación',
    'feedback_method': 'método de retroalimentación',
    'file_name': 'Nombre de archivo',
    'file_size': 'Tamaño del archivo',
    'file_type': 'Tipo de archivo',
    'floating_ips': 'IPs flotantes',
    'force_logout_message': 'Tu configuración ha cambiado. Necesitarás cerrar sesión para que estos cambios surtan efecto.',
    'force_rollback': 'Reversión forzada',
    'force_unlock': 'Desbloqueo forzado',
    'force_upload': 'Forzar carga',
    'force_upload_message': '¿Quieres continuar con la carga?',
    'forgot_password': '¿Olvidaste tu contraseña?',
    'forwarding_mode': 'Modo de reenvío',
    'free_download': 'Descarga gratuita',
    'go_back': 'Volver',
    'help_loadbalancer': 'Ayuda del equilibrador de carga',
    'help_portal': 'Ayuda del portal',
    'hidden_columns': 'Columnas ocultas',
    'host_name': 'Nombre de host',
    'http_connection': 'Conexión HTTP',
    'ip_address': 'Dirección IP',
    'items_per_page': 'Elementos por página',
    'knowledge_base': 'Base de conocimientos',
    'last_alert': 'Última alerta',
    'last_checked': 'Última comprobación',
    'layer_7_advanced': 'Avanzado de capa 7',
    'licence_company_name': 'Nombre de la empresa',
    'licence_key': 'Clave de licencia',
    'load_balancer': 'Balanceador de carga',
    'log_level': 'Nivel de registro',
    'login_in': 'Iniciar sesión',
    'mac_address': 'dirección MAC',
    'max_conns': 'Conexiones máximas',
    'maximum_length': 'La longitud máxima de caracteres es ',
    'minimum_length': 'La longitud mínima de caracteres es',
    'name_first': 'Nombre',
    'name_last': 'Apellido',
    'network_address': 'dirección de red',
    'no_matches': 'No hay coincidencias',
    'no_more_content': 'No más contenido',
    'none_set': 'Ninguno configurado',
    'nothing_configured': 'Nada configurado.',
    'password_confirm': 'Confirmar contraseña',
    'per_month': 'por mes',
    'per_year': 'por año',
    'polaris lb': 'Polaris LB',
    'polaris topology': 'Topología de Polaris',
    'product_name': 'Nombre del producto',
    'product_type': 'Tipo de producto',
    'read_write': 'lectura/escritura',
    'real_servers': 'Servidores reales',
    'release_version': 'Versión de lanzamiento',
    'restart_haproxy': 'Reiniciar HaProxy',
    'save_file': 'Guardar archivo',
    'select_all': 'Seleccionar todo',
    'service_outage': 'Servicio de corte',
    'service_status': 'Estado del servicio',
    'skip_to_finish': 'Saltar al final',
    'software_updates': 'Actualizaciones de software',
    'ssl_certificate': 'Certificado SSL',
    'ssl_max_version': 'Versión máxima de SSL',
    'ssl_min_version': 'Versión mínima de SSL',
    'ssl_term': 'Terminación SSL',
    'start_free_trial': 'Iniciar prueba gratuita',
    'submit_disabled': 'El envío está deshabilitado porque el formulario no ha cambiado.',
    'subnet_add': 'Agregar subred',
    'subnet_delete': 'Eliminar subred',
    'subnet_delete_message': '¿Está seguro de que desea eliminar la subred ',
    'subnet_edit': 'Editar subred',
    'system_control': 'Control del sistema',
    'thank_you': 'Gracias',
    'timed_out': 'Tiempo agotado',
    'turn_off': 'Apagar',
    'upgrade_options': 'Opciones de actualización',
    'username_email': 'Nombre de usuario/Correo electrónico',
    'value_greater_than': 'El valor debe ser mayor que ',
    'value_less_than': 'El valor debe ser menor que ',
    'view_config_snmp_conf': 'Configuración SNMP',
    'view_service_status': 'Ver estado del servicio',
    'welcome_to_endurance': 'Bienvenido a Endurance',
    'welcome_to_admin_panel': 'Bienvenido al Portal Admin',
    'welcome_to_portal': 'Bienvenido al Portal',
    'zero_downtime': 'Tiempo de inactividad cero',

    // Single words
    'account': 'Cuenta',
    'accounts': 'Cuentas',
    'acl': 'ACL',
    'acls': 'ACLs',
    'action': 'Acción',
    'activate': 'Activar',
    'active': 'Activo',
    'adc': 'ADC',
    'adcs': 'ADCs',
    'add': 'Agregar',
    'address': 'Dirección',
    'adopt': 'Adoptar',
    'adopted': 'Adoptado',
    'adoption': 'Adopción',
    'adopting': 'Adoptando',
    'advanced': 'Avanzado',
    'aes': 'AES',
    'ago': 'hace',
    'alerts': 'Alertas',
    'and': 'Y',
    'apply': 'Aplicar',
    'arch': 'Arquitectura',
    'attention': 'Atención',
    'authentication': 'Autenticación',
    'available': 'disponible',
    'back': 'Volver',
    'backend': 'Backend',
    'backends': 'Backends',
    'backup': 'Copia de seguridad',
    'backups': 'Copias de seguridad',
    'billing': 'Facturación',
    'bond': 'Vínculo',
    'break': 'Romper',
    'builtin': 'Integrado',
    'bytes': 'bytes',
    'ca': 'CA',
    'cancel': 'Cancelar',
    'central': 'Central',
    'certificate': 'Certificado',
    'certificates': 'Certificados',
    'certs': 'Certificados',
    'change': 'Cambiar',
    'chat': 'Chat',
    'cidr': 'CIDR',
    'cipher': 'Cifrado',
    'cipher_usage': 'Uso de cifrado',
    'ciphers': 'Cifrados',
    'close': 'Cerca',
    'code': 'Código',
    'collectors': 'Coleccionistas',
    'coming_soon': 'Próximamente',
    'condition': 'Condición',
    'config': 'Configuración',
    'confirm': 'Confirmar',
    'conn': 'Conex.',
    'connect': 'Conectar',
    'connection': 'Conexión',
    'connections': 'Conexiones',
    'contact': 'Contacto',
    'continue': 'Continuar',
    'copy': 'Copiar',
    'copyright': 'Derechos de autor ©',
    'count': 'Contador',
    'create': 'Crear',
    'critical': 'Crítico',
    'crl': 'CRL',
    'csr': 'CSR',
    'date': 'Fecha',
    'day': 'día',
    'days': 'días',
    'days_upper': 'Días',
    'debug': 'Depurar',
    'default': 'Predeterminado',
    'dashboard': 'Tablero',
    'database': 'Base de datos',
    'delete': 'Eliminar',
    'des': 'DES',
    'description': 'Descripción',
    'details': 'Detalles',
    'direct': 'Directo',
    'disabled': 'Desactivado',
    'disconnect': 'Desconectar',
    'documentation': 'Documentación',
    'domain': 'Dominio',
    'done': 'Listo',
    'down': 'Inactivo',
    'downgrade': 'Degradar',
    'download': 'Descargar',
    'downloads': 'Descargas',
    'drain': 'Drenar',
    'duplicate': 'Duplicado',
    'edit': 'Editar',
    'email': 'Correo electrónico',
    'enable': 'Habilitar',
    'enabled': 'Habilitado',
    'endurance': 'Endurance',
    'enforce': 'Hacer cumplir',
    'enterprise': 'Empresa',
    'error': 'Error',
    'execute': 'Ejecutar',
    'existing': 'Existente',
    'expires': 'Caduca',
    'external': 'Externo',
    'external_privacy': 'Privacidad',
    'external_terms': 'Términos',
    'failure': 'Falla',
    'fall': 'Caída',
    'fallback': 'Respaldo',
    'feedback': 'Retroalimentación',
    'file': 'Archivo',
    'finish': 'Finalizar',
    'fips': 'FIPs',
    'firewall': 'Firewall',
    'for': 'para',
    'forced': 'Forzado',
    'format': 'Formato',
    'forward': 'Reenviar',
    'forwarding': 'Reenvío',
    'from': 'De',
    'frontend': 'Frontend',
    'frontends': 'Frontends',
    'gateway': 'Puerta de enlace',
    'general': 'General',
    'gid': 'GID',
    'granularity': 'Granularidad',
    'group': 'Grupo',
    'groups': 'Grupos',
    'gslb': 'GSLB',
    'halt': 'Detener',
    'haproxy': 'HAProxy',
    'has': 'tiene',
    'headers': 'Encabezados',
    'health': 'Estado',
    'healthcheck': 'control de salud',
    'high': 'Alto',
    'hostname': 'Nombre de host',
    'hour': 'hora',
    'hours': 'horas',
    'http': 'HTTP',
    'hypervisor': 'Hipervisor',
    'hypervisors': 'Hipervisores',
    'id': 'ID',
    'if': 'Si',
    'import': 'Importar',
    'in': 'en',
    'information': 'Información',
    'interface': 'Interfaz',
    'interfaces': 'Interfaces',
    'interval': 'Intervalo',
    'ip': 'IP',
    'ips': 'IPs',
    'ipv4': 'IPv4',
    'ipv6': 'IPv6',
    'is': 'es',
    'issue': 'Problema',
    'json': 'JSON',
    'kb': 'kB',
    'keyboard': 'Teclado',
    'keymap': 'Mapa de teclas',
    'l4': 'Capa 4',
    'l7': 'Capa 7',
    'label': 'Etiqueta',
    'licensing': 'Licencias',
    'lines': 'Líneas',
    'list': 'Lista',
    'loading': 'Cargando...',
    'local': 'local',
    'log': 'Registro',
    'logout': 'Cerrar sesión',
    'logs': 'Registros',
    'low': 'Bajo',
    'maintenance': 'Mantenimiento',
    'manage': 'Administrar',
    'mask': 'Máscara',
    'max': 'Máx.:',
    'md5': 'MD5',
    'medium': 'Medio',
    'member': 'Miembro',
    'members': 'Miembros',
    'method': 'Método',
    'minute': 'minuto',
    'minutes': 'minutos',
    'mode': 'Modo',
    'modes': 'Modos',
    'monitor': 'Monitoreo',
    'month': 'mes',
    'months': 'meses',
    'more': 'Más',
    'ms': '(ms)',
    'n_a': 'n/d',
    'name': 'Nombre',
    'namespace': 'Espacio de nombres',
    'network': 'Red',
    'new': 'Nuevo',
    'news': 'Noticias',
    'next': 'Siguiente',
    'node': 'Nodo',
    'nodes': 'Nodos',
    'notes': 'Notas',
    'notification': 'Notificación',
    'notifications': 'Notificaciones',
    'occurrence': 'Ocurrencia',
    'of': 'de',
    'off': 'apagado',
    'offline': 'Desconectado',
    'ok': 'Ok',
    'online': 'En línea',
    'option': 'Opción',
    'optional': 'opcional',
    'options': 'Opciones',
    'or': 'O',
    'order': 'orden',
    'organization': 'Organización',
    'organizations': 'Organizaciones',
    'overview': 'Resumen',
    'passive': 'Pasivo',
    'password': 'Contraseña',
    'paths': 'rutas',
    'pending': 'Pendiente',
    'percentage': '%',
    'permission': 'permiso',
    'persistence': 'Persistencia',
    'place': 'lugar',
    'places': 'lugares',
    'platform': 'Plataforma',
    'pools': 'Pools',
    'port': 'Puerto',
    'portal': 'Portal',
    'ports': 'Puertos',
    'primary': 'Primario',
    'priority': 'Prioridad',
    'product': 'Producto',
    'products': 'Productos',
    'prometheus': 'Prometeo',
    'protocol': 'Protocolo',
    'provider': 'Proveedor',
    'proxy': 'Proxy',
    'purchase': 'Compra',
    'range': 'Rango',
    'rbac': 'RBAC',
    'read': 'Leer',
    'ready': 'Listo',
    'recovery': 'Recuperación',
    'references': 'Referencias',
    'region': 'Región',
    'regions': 'Regiones',
    'reload': 'Recargar',
    'relogin': 'Volver a iniciar sesión',
    'remove': 'Eliminar',
    'renew': 'Renovar',
    'repeat': 'Repetir',
    'replace': 'reemplazar',
    'reply': 'Responder',
    'reports': 'Informes',
    'resources': 'Recursos',
    'reset': 'Restablecer',
    'restart': 'Reiniciar',
    'restore': 'Restaurar',
    'rise': 'Aumentar',
    'role': 'Rol',
    'roles': 'Roles',
    'routing': 'Enrutamiento',
    'rows': 'filas',
    'rules': 'regla(s)',
    'save': 'Guardar',
    'schedule': 'Programar',
    'schedules': 'Programas',
    'search': 'Buscar',
    'search_placeholder': 'Buscar...',
    'second': 'segundo',
    'secondary': 'Secundario',
    'seconds': 'segundos',
    'section': 'sección',
    'select': 'Seleccionar',
    'selected': 'Seleccionados',
    'send': 'Enviar',
    'serial': 'Serial',
    'server': 'Servidor',
    'service': 'Servicio',
    'services': 'Servicios',
    'settings': 'Ajustes',
    'setup': 'Configuración',
    'sha': 'SHA',
    'shutdown': 'Apagar',
    'shuttle': 'Transbordador',
    'sidecar': 'Sidecar',
    'sips': 'SIPs',
    'size': 'Tamaño',
    'size_b': 'Tamaño (B)',
    'size_kb': 'Tamaño (kB)',
    'size_mb': 'Tamaño (MB)',
    'smtp': 'SMTP',
    'snmp': 'SNMP',
    'speed': 'Velocidad',
    'ssl': 'SSL',
    'start': 'Iniciar',
    'state': 'Estado',
    'status': 'Estado',
    'step': 'Paso',
    'storage': 'Almacenamiento',
    'subject': 'Asunto',
    'submit': 'Enviar',
    'subnet': 'Subred',
    'subnets': 'Subredes',
    'subscription': 'Suscripción',
    'subscriptions': 'Suscripciones',
    'success': 'Éxito',
    'successful': 'exitoso',
    'system': 'Sistema',
    'tcp': 'TCP',
    'teams': 'Equipos',
    'templates': 'Plantillas',
    'tertiary': 'Terciario',
    'theme': 'Tema',
    'then': 'Entonces',
    'tier': 'Nivel',
    'tiers': 'Niveles',
    'time': 'Tiempo',
    'to': 'a',
    'to_upper': 'A',
    'today': 'hoy',
    'token': 'simbólico',
    'topologies': 'Topologías',
    'total': 'total',
    'ttl': 'TTL',
    'type': 'Tipo',
    'unlimited': 'Ilimitado',
    'up': 'arriba',
    'update': 'Actualizar',
    'updating': 'Actualizando',
    'upgrade': 'Actualizar',
    'upload': 'Subir',
    'usage': 'Uso',
    'user': 'Usuario',
    'username': 'Nombre de usuario',
    'users': 'Usuarios',
    'valid_to': 'Válido hasta',
    'value': 'Valor',
    'vendor': 'Proveedor',
    'verify': 'Verificar',
    'version': 'Versión',
    'via': 'A través de',
    'view': 'Ver',
    'vlan': 'VLAN',
    'vlans': 'VLANs',
    'warning': 'Advertencia',
    'warp': 'Warp',
    'weight': 'Peso',
    'welcome': 'Bienvenido',
    'with': 'con',
    'year': 'año',
    'years': 'años',
    'zero': 'Cero',

    // Subscription page
    'adc_backups': 'Copias de seguridad de ADC',
    'online_updates': 'Actualizaciones en línea',
    'asset_scheduling': 'Programación de activos',
    'dedicated_success_manager': 'Gerente de éxito dedicado',
    'professional_services': 'Servicios profesionales',
    'secure_direct_access': 'Acceso directo seguro',
    'secure_warp_remote_access': 'Acceso remoto seguro Warp',
    'adc_security_insights': 'Información de seguridad de ADC',
    'adc_certificate_insights': 'Información de certificados de ADC',
    'single_sign_on': 'Inicio de sesión único (G Suite + Azure AD)',
    'single_sign_on_tailored': 'Inicio de sesión único (G Suite + Azure AD + SAML)',
    '2fa': 'Autenticación de dos factores (SMS + APP)',
    'audit_log': 'Registro de auditoría',
    'license_management': 'Gestión de licencias',
    'api_access': 'Acceso API',
    'asset_scheduling_pipelines': 'Programación de activos: tuberías',
    'white_label': 'Etiqueta Blanca',

    // TODO remove when RBAC complete
    'user_invite_new': 'Invitar usuario',
    'user_permissions': 'Permisos de usuario',

    // Validation messages
    'base_64_not_found': 'No se puede encontrar BASE64',
    'domain_validation_error': 'Nombre de dominio no válido. Por favor, asegúrese de lo siguiente: ' +
        '<ul>\n' +
        '<li>El nombre de dominio contiene solo caracteres alfanuméricos, guiones o puntos <br>y comienza y termina con un carácter alfanumérico.</li>\n' +
        '<li>El nombre de dominio no supera los 253 caracteres de longitud total.</li>\n' +
        '<li>Cada etiqueta (subparte del nombre de dominio separada por puntos) tiene entre 1 y 63 caracteres de longitud.</li>\n' +
        '<li>No se permiten espacios ni caracteres especiales (excepto guiones y puntos).</li>\n' +
        '</ul>',
    'duplicate_adc_label': 'Ya existe un ADC con esta etiqueta.',
    'duplicate_already_in_use': 'Duplicado. Ya en uso.',
    'duplicate_certificate_label': 'Ya existe un certificado con esta etiqueta.',
    'duplicate_cipher_list': 'Ya existe una lista de cifrados con esta etiqueta.',
    'duplicate_fip': 'Dirección IP flotante duplicada',
    'duplicate_global_name': 'Ya existe un nombre global con esta etiqueta.',
    'duplicate_group_ip': 'Esta IP ya está asignada a otro grupo.',
    'duplicate_group_name': 'Nombre de grupo duplicado',
    'duplicate_header_name_type': 'Ya existe un encabezado con este nombre y tipo.',
    'duplicate_hostname': 'Este nombre de host ya existe.',
    'duplicate_member_prefix': 'Un miembro con este ',
    'duplicate_name': 'Este nombre ya está en uso.',
    'duplicate_namespace': 'Este espacio de nombres ya existe.',
    'duplicate_pool': 'Ya existe un grupo con este nombre.',
    'duplicate_port': 'Puerto duplicado',
    'duplicate_role_name': 'Nombre de rol duplicado.',
    'duplicate_route': 'Esta ruta ya está en uso.',
    'duplicate_sip': 'Dirección IP estática duplicada',
    'duplicate_subnet': 'Subred duplicada',
    'duplicate_value': 'Este es un valor duplicado.',
    'email_in_use': 'Ya existe un usuario con este correo electrónico.',
    'email_mismatch': 'Confirmar que el correo electrónico no coincide con el correo electrónico.',
    'file_extension_not_found': 'No se puede encontrar la extensión del archivo.',
    'headers_invalid_text': `Las áreas de texto de encabezados L7 no deben contener caracteres no válidos.<br>
        <ul>
        <li>Permitidos</li>
        <ul>
        <li>application/json</li>
        <li>text/html; charset=utf-8</li>
        <li>Mon, 27 Jul 2009 12:28:53 GMT</li>
        <li>  valor con espacios  </li>
        <li>\\t carácter de control</li>
        </ul>
        <li>No Permitidos</li>
        <ul>
        <li>∑ caracteres Unicode €</li>
        <li>\\u001F caracteres de control</li>
        <li>\\n \\r caracteres de control</li>
        </ul>
        </ul>`,
    'hostname_validation_error_message': 'Nombre de host no válido. Por favor, asegúrese de lo siguiente: <br>\n' +
        '<ul>\n' +
        '<li>El nombre de host contiene solo caracteres alfanuméricos y guiones (-).</li>\n' +
        '<li>Debe comenzar y terminar con un carácter alfanumérico.</li>\n' +
        '<li>La longitud total del nombre de host no debe superar los 253 caracteres.</li>\n' +
        '<li>Los nombres de host no pueden ser completamente numéricos y deben incluir al menos un carácter alfabético.</li>\n' +
        '<li>No se permiten espacios, caracteres especiales ni guiones bajos (_).</li>\n' +
        '<li>Los nombres de host no distinguen entre mayúsculas y minúsculas.</li>\n' +
        '</ul>',
    'incorrect_password': 'Contraseña incorrecta.',
    'invalid_card_number': 'Número de tarjeta no válido',
    'invalid_certificate': 'Certificado no válido.',
    'invalid_cidr': 'CIDR no válido.',
    'invalid_email_address': 'Dirección de correo electrónico no válida.',
    'invalid_email_address_length': 'Dirección de correo electrónico no válida, demasiado larga',
    'invalid_file_type': 'La carga de archivos debe tener la extensión .pem o .pfx.',
    'invalid_integer': 'Valor no es un número válido',
    'invalid_ip': 'Dirección IP no válida.',
    'invalid_ip_cidr': 'Utilice la notación correcta para IP/CIDR, por ejemplo, 127.0.0.1/24.',
    'invalid_ip_domain': 'Dirección IP o dominio no válido.',
    'invalid_ipv4': 'Dirección IPv4 no válida.',
    'invalid_ipv6': 'Dirección IPv6 no válida.',
    'invalid_ip_long': `La dirección IP no es válida. Asegúrese de que tiene un formato válido de IPv4 o IPv6.<br>
                Una dirección IPv4 debe:<br>
                <ul>
                <li>Contener 4 números separados por puntos  </li>
                 <li>Cada número debe estar entre 0 y 255 </li>
                 <li>No puede comenzar con 0  </li>
                 </ul>
                Una dirección IPv6 debe contener:<br>
                <ul>
                <li>8 grupos de dígitos hexadecimales separados por dos puntos.</li>
                <li>Cada dígito hexadecimal debe estar entre 0 y 65535.</li>
                </ul>`,
    'invalid_ip_or_domain': 'Dominio o dirección IP no válido.',
    'invalid_name_characters': 'Caracteres no válidos. Solo debe contener una combinación de: a-z A-Z 0-9_- {} [] () . , \' y espacio',
    'invalid_name_start_space': 'Los nombres no pueden comenzar con un espacio.',
    'invalid_name_length': 'La longitud del campo es demasiado larga. Debe ser menor de 253 caracteres.',
    'invalid_name_length_short': 'La longitud del campo es demasiado corta. Debe tener más de 2 caracteres.',
    'invalid_passcode': 'Código no válido. Inténtalo de nuevo.',
    'invalid_password_simple': 'Contraseña no válida. La contraseña debe tener al menos 8 caracteres, contener 1 mayúscula, 1 número, 1 minúscula y no debe incluir caracteres especiales, por ejemplo, !&$£@',
    'invalid_password_complex': 'ontraseña no válida. Debe tener entre 8 y 128 caracteres, incluyendo una mayúscula, un número, una minúscula y un carácter especial (como !@#$%^&£?*-).',
    'invalid_path_end': 'El final de la ruta debe comenzar con un \'.\'',
    'invalid_path_start': 'La ruta debe comenzar con una barra inclinada: /',
    'invalid_phone_number': 'Número de teléfono no válido. El símbolo + es opcional, pero el primer dígito debe ser 1-9, seguido de hasta 14 dígitos (0-9).',
    'invalid_port_range': 'Puerto no válido. El rango de puertos debe estar entre 1 y 65535',
    'invalid_redirect_location': 'Ubicación de redirección no válida.',
    'invalid_san': 'SAN no válido. Los formatos aceptables incluyen direcciones IP, direcciones de correo electrónico, dominios y subdominios.',
    'invalid_start_time': 'La hora de inicio no puede estar en el futuro.',
    'invalid_time_unit': 'Unidad de tiempo no válida, debe ser: us/ms/s/m/h/d',
    'l7_mode_reset_error': 'Este campo se ha restablecido porque el modo ha cambiado y el valor anterior no era compatible con el modo actual.',
    'label_in_use': 'Esta etiqueta ya está en uso.',
    'multiport_invalid_format': 'Formato de puerto no válido. Los valores deben estar entre 0-9. Separadores: , o -',
    'multiport_out_of_range': 'Puerto no válido. No está entre 1 y 65535',
    'no_logs_before': 'No hay registros antes de ',
    'password_mismatch': 'Las contraseñas no coinciden.',
    'port_none_checked_error': 'Debe seleccionarse al menos una opción de puerto.',
    'port_range_overlap': 'Este rango se superpone con otro.',
    'url_validation': 'URL no válida'
};
